<template>
  <div
    v-click-outside="closeAll"
    class="client-tags "
    :id="'carousel-' + client.id"
  >
    <!--    @click="showForm = true"-->

    <div
      class="add-tag-wrapper"
      :class="{ 'add-tag-wrapper-status': selectedTab !== 'status' }"
      @click="showForm = true"
    >
      <div>
        <div
          class="dropdown forPlus special-dropdown"
          v-tooltip="{ content: `Add tag` }"
        >
          <!--          <span>-->
          <!--          <i-->
          <!--            class="fas fa-plus tmp"-->
          <!--            :class="{'hajTemp':plusHovered}"-->
          <!--            data-toggle="dropdown forPlus"-->
          <!--            @click="showForm = true"-->
          <!--            @mouseenter="plusHovered = true"-->
          <!--            @mouseleave="plusHovered = false"-->
          <!--            v-if="!lockTagBtn && auth.user.id !== 114"-->
          <!--          ></i>-->
          <!--</span>-->
          <i
            class="fas fa-plus newPlusBtn"
            @click.stop="showForm = true"
            v-if="!lockTagBtn && auth.user.id !== 114"
          ></i>
          <div
            :class="{ 'div-for-edit-only': client.is_merged === 1 }"
            class="dropdown-menu for-un-closing"
            v-if="showForm"
            style="display:block"
            @click.stop
          >
            <form>
              <div v-if="showForm">
                <div class="panel-group" id="accordion">
                  <div
                    v-show="client.is_merged !== 1"
                    class="panel panel-default"
                  >
                    <div class="panel-heading dp">
                      <h4 class="panel-title ">
                        <!--showForm=false-->
                        <a
                          class="tag-name"
                          @click="
                            [
                              (showDepositForm = !showDepositForm),
                              sendVuexToCal(client.id),
                              (depositDate = true)
                            ]
                          "
                          data-toggle="collapse"
                          data-parent="#accordion"
                          :href="'#collapse7-' + client.id"
                          >DEPOSIT</a
                        >
                        <a
                          @click="
                            [
                              (showDepositForm = !showDepositForm),
                              sendVuexToCal(client.id),
                              (depositDate = true)
                            ]
                          "
                          data-toggle="collapse"
                          data-parent="#accordion"
                          :href="'#collapse7-' + client.id"
                          class="label tag-deposit-newV"
                          >DP</a
                        >
                      </h4>
                    </div>
                    <div
                      :id="'collapse7-' + client.id"
                      class="panel-collapse"
                      v-show="showDepositForm"
                    >
                      <div class="panel-body">
                        <div
                          v-if="CheckUserPermission([1, 2, 3, 4, 12])"
                          class="dateFromCal"
                          :class="{
                            'dateFromCal-red': deposit.dep_date === null
                          }"
                          @click="
                            [
                              (showDepCal = !showDepCal),
                              (deposit.dep_date = ''),
                              (datePickerKey += 1)
                            ]
                          "
                        >
                          {{
                            createMoment(deposit.dep_date) !== "Invalid date"
                              ? createMoment(deposit.dep_date)
                              : textOrDate
                          }}
                        </div>
                        <div v-if="showDepositForm">
                          <ul class="nav nav-tabs">
                            <li
                              v-for="tab in returnDepMenuTabs()"
                              :key="tab.id"
                              :class="{
                                active: selectedDepMenuTab === tab.alias
                              }"
                            >
                              <button
                                @click="selectedDepMenuTab = tab.alias"
                                type="button"
                                class="btn btn-secondary nav-btn"
                              >
                                {{ tab.name }}
                              </button>
                              <!--                              <a-->
                              <!--                                href="javascript:void(0)"-->
                              <!--                                @click="selectedDepMenuTab = tab.alias"-->
                              <!--                              >-->
                              <!--                                {{ tab.name }}-->
                              <!--                              </a>-->
                            </li>
                          </ul>

                          <div v-if="selectedDepMenuTab === 'MAIN'">
                            <div v-if="CheckUserPermission([1, 2, 3, 4, 12])">
                              <div class="form-group mainCalNewV">
                                <!--                                <i-->
                                <!--                                  v-if="-->
                                <!--                                  (-->
                                <!--                                  requestForDate &&-->
                                <!--                                  requestForDate.tagName === 'dp' &&-->
                                <!--                                  requestForDate.id === client.id-->
                                <!--                                ) &&-->
                                <!--                                    ((requestForDate.date == null ||-->
                                <!--                                      requestForDate.time == null) &&-->
                                <!--                                      !depositDate)-->
                                <!--                                  "-->
                                <!--                                  class="fas fa-window-close clickable "-->
                                <!--                                  @click.stop="-->
                                <!--                                    [-->
                                <!--                                      sendVuexToCal(),-->
                                <!--                                      (clickedOnDateChange = true)-->
                                <!--                                    ]-->
                                <!--                                  "-->
                                <!--                                ></i>-->
                                <!--                                <span class="text-danger text-uppercase "-->
                                <!--                                  >{{ textOrDate }}-->
                                <!--                                </span>-->
                                <i
                                  @click.stop="sendNewDateFromPopUpToDB"
                                  class="fas fa-check pointer "
                                  v-if="
                                    requestForDate.date != null &&
                                      requestForDate.time != null &&
                                      requestForDate.id === client.id &&
                                      !depositDate
                                  "
                                ></i>
                                <!--                                <span v-if="!depositDate">{{ textOrDate }}</span>-->

                                <!--                                <date-picker-->
                                <!--                                  :key="datePickerKey"-->
                                <!--                                  v-show="showDepCal"-->
                                <!--                                  lang="en"-->
                                <!--                                  v-model="deposit.dep_date"-->
                                <!--                                  :first-day-of-week="1"-->
                                <!--                                  type="datetime"-->
                                <!--                                  :minute-step="1"-->
                                <!--                                  :time-picker-options="timePickerOptions"-->
                                <!--                                  input-class="form-control input-sm"-->
                                <!--                                  @change="showOrHide"-->
                                <!--                                  inline-->
                                <!--                                ></date-picker>-->
                              </div>
                            </div>
                            <div v-show="!showDepCal" class="custom-select">
                              <div
                                class="add-tag-menu-item-title"
                                v-if="CheckUserPermission([1, 2, 3, 4, 12])"
                              >
                                <p
                                  :class="{
                                    errColor: deposit.errors.hasOwnProperty(
                                      'user_id'
                                    )
                                  }"
                                  @click="
                                   [ openCustomSelectF1 = !openCustomSelectF1,depForSerch = '']
                                  "
                                >
                                  {{
                                    optionClickedF1 != null &&
                                    !deposit.errors.hasOwnProperty("user_id")
                                      ? optionClickedF1
                                      : "Deposit For"
                                  }}
                                </p>
                                <input
                                  v-show="openCustomSelectF1"
                                  class="input-standard-for-dep"
                                  type="search"
                                  placeholder="Search Dep For"
                                  v-model="depForSerch"
                                  @click="openDepForList = true"
                                  @change="openDepForList = true"
                                />

                                <ul
                                  class="assign-menu-item"
                                  v-for="user in depForSerch.length > 0 || depForSerchResults.length > 0 ? depForSerchResults: salesPersonList"
                                  :key="user.id"
                                  :value="user.id"
                                  v-show="openCustomSelectF1"
                                >
                                  <li
                                    @click="
                                      [
                                        (deposit.user_id = user.id),
                                        (openCustomSelectF1 = !openCustomSelectF1),
                                        (optionClickedF1 = user.full_name),
                                        (deposit.errors = {}),
                                           depForSerch = ''
                                      ]
                                    "
                                  >
                                    {{ user.full_name }}
                                  </li>
                                </ul>
                              </div>
                              <!--                              <select-->
                              <!--                                v-if="CheckUserPermission([1, 2, 3, 4, 12])"-->
                              <!--                                class="form-control input-sm"-->
                              <!--                                v-model="deposit.user_id"-->
                              <!--                              >-->
                              <!--                                <option :value="null">Deposit For</option>-->
                              <!--                                <option-->
                              <!--                                  v-for="user in salesPersonList"-->
                              <!--                                  :key="user.id"-->
                              <!--                                  :value="user.id"-->
                              <!--                                  >{{ user.full_name }}-->
                              <!--                                </option>-->
                              <!--                              </select>-->

                              <p></p>
                              <div
                                class="form-group"
                                :class="{
                                  'has-error': deposit.errors.hasOwnProperty(
                                    'campaign_id'
                                  )
                                }"
                              >
                                <div class="add-tag-menu-item-title">
                                  <p
                                    :class="{
                                      errColor: deposit.errors.hasOwnProperty(
                                        'campaign_id'
                                      )
                                    }"
                                    @click="
                                      [openCustomSelectF2 = !openCustomSelectF2,campaignSerch = '']
                                    "
                                  >
                                    {{
                                      optionClickedF2 != null &&
                                      !deposit.errors.hasOwnProperty(
                                        "campaign_id"
                                      )
                                        ? optionClickedF2
                                        : "Select campaign"
                                    }}


                                  </p>
                                  <input
                                      v-show="openCustomSelectF2"
                                      class="input-standard-for-dep"
                                      type="search"
                                      placeholder="Search Campaign"
                                      v-model="campaignSerch"
                                      @click="openCampaignList = true"
                                      @change="openCampaignList = true"
                                  />

                                  <ul

                                    class="assign-menu-item"
                                    v-for="campaign in campaignSerch.length > 0  ||campaignSerchResults.length > 0 ? campaignSerchResults: filterExistingBroker(FilterNonActiveBrokers())"
                                    :key="campaign.id"
                                    :value="campaign.id"
                                    v-show="openCustomSelectF2 "
                                  >

                                    <li
                                      @click="
                                        [
                                          (deposit.campaign_id = campaign.id),
                                          (openCustomSelectF2 = !openCustomSelectF2),
                                          (optionClickedF2 = campaign.name),
                                          (deposit.errors = {}),
                                          campaignSerch = ''
                                        ]
                                      "
                                    >
                                      {{ campaign.name }}
                                    </li>
                                  </ul>

                                </div>

                                <!--                                <select-->
                                <!--                                  class="form-control input-sm"-->
                                <!--                                  v-model="deposit.campaign_id"-->
                                <!--                                >-->
                                <!--                                  <option :value="null">Select campaign</option>-->
                                <!--                                  <option-->
                                <!--                                    v-for="campaign in filterExistingBroker(-->
                                <!--                                      FilterNonActiveBrokers()-->
                                <!--                                    )"-->
                                <!--                                    :key="campaign.id"-->
                                <!--                                    :value="campaign.id"-->
                                <!--                                    >{{ campaign.name }}-->
                                <!--                                  </option>-->
                                <!--                                </select>-->
                                <!--                                <p-->
                                <!--                                  v-if="-->
                                <!--                                    deposit.errors.hasOwnProperty('campaign_id')-->
                                <!--                                  "-->
                                <!--                                  class="help-block"-->
                                <!--                                >-->
                                <!--                                  Campaign empty-->
                                <!--                                </p>-->
                                <!--                                -->
                              </div>

                              <div
                                class="form-group"
                                :class="{
                                  'has-error': deposit.errors.hasOwnProperty(
                                    'status_id'
                                  )
                                }"
                              >
                                <div class="add-tag-menu-item-title">
                                  <p
                                    :class="{
                                      errColor: deposit.errors.hasOwnProperty(
                                        'status_id'
                                      )
                                    }"
                                    @click="
                                    [  openCustomSelectF3 = !openCustomSelectF3,depStatSerch = '']
                                    "
                                  >
                                    {{
                                      optionClickedF3 != null &&
                                      !deposit.errors.hasOwnProperty(
                                        "status_id"
                                      )
                                        ? optionClickedF3
                                        : "Select status"
                                    }}
                                  </p>
                                  <input
                                    v-show="openCustomSelectF3"
                                    class="input-standard-for-dep"
                                    type="search"
                                    placeholder="Search Status"
                                    v-model="depStatSerch"
                                    @click="openDepStatList = true"
                                    @change="openDepStatList = true"
                                  />
                                  <ul
                                    class="assign-menu-item"
                                    v-for="status in depStatSerch.length > 0 || depStatSerchResults.length > 0 ? depStatSerchResults: checkPrivileges(
                                      dictionaries.activity.client_deposit_types
                                    )"
                                    :key="status.id"
                                    :value="status.id"
                                    v-show="openCustomSelectF3"
                                  >
                                    <li
                                      @click="
                                        [
                                          (deposit.status_id = status.id),
                                          (openCustomSelectF3 = !openCustomSelectF3),
                                          (optionClickedF3 = status.type),
                                          (deposit.errors = {}),
                                          depStatSerch = ''
                                        ]
                                      "
                                    >
                                      {{ status.type }}
                                    </li>
                                  </ul>
                                </div>

                                <!--                                <select-->
                                <!--                                  class="form-control input-sm"-->
                                <!--                                  v-model="deposit.status_id"-->
                                <!--                                >-->
                                <!--                                  <option :value="null">Select status</option>-->
                                <!--                                  <option-->
                                <!--                                    v-for="status in checkPrivileges(-->
                                <!--                                      dictionaries.activity.client_deposit_types-->
                                <!--                                    )"-->
                                <!--                                    :key="status.id"-->
                                <!--                                    :value="status.id"-->
                                <!--                                    >{{ status.type }}-->
                                <!--                                  </option>-->
                                <!--&lt;!&ndash;                                </select>&ndash;&gt;-->
                                <!--                                <p-->
                                <!--                                  v-if="-->
                                <!--                                    deposit.errors.hasOwnProperty('status_id')-->
                                <!--                                  "-->
                                <!--                                  class="help-block"-->
                                <!--                                >-->
                                <!--                                  &lt;!&ndash;              {{ deposit.errors.status }}&ndash;&gt;-->
                                <!--                                  Status empty-->
                                <!--                                </p>-->
                              </div>
                              <p></p>
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control input-sm sum"
                                  style="margin-bottom:0;"
                                  v-model="deposit.amount"
                                  placeholder="Amount"
                                />
                                <div class="add-tag-menu-item-title for-cur">
                                  <p
                                    @click="
                                      [openCustomSelectF4 = !openCustomSelectF4,depMethodsSerch = '']
                                    "
                                  >
                                    {{
                                      optionClickedF4 != null
                                        ? optionClickedF4
                                        : "$ USD"
                                    }}
                                  </p>
                                  <input
                                    v-show="openCustomSelectF4"
                                    class="input-standard-for-dep"
                                    type="search"
                                    placeholder="Search Campaign"
                                    v-model="depMethodsSerch"
                                    @click="openDepMethodsList = true"
                                    @change="openDepMethodsList = true"
                                  />
                                  <ul
                                    class="assign-menu-item"
                                    v-for="curr in  dictionaries.activity
                                      .currency_types"
                                    :key="curr.id"
                                    :value="curr.id"
                                    v-show="openCustomSelectF4"
                                  >
                                    <li
                                      @click="
                                        [
                                          (deposit.currency_id = curr.id),
                                          (openCustomSelectF4 = !openCustomSelectF4),
                                          (optionClickedF4 =
                                            curr.symbol + ' ' + curr.name),
                                          (deposit.errors = {})
                                        ]
                                      "
                                    >
                                      {{ curr.symbol + " " + curr.name }}
                                    </li>
                                  </ul>
                                </div>

                                <!--                                <select-->
                                <!--                                  class="form-control input-sm"-->
                                <!--                                  v-model="deposit.currency_id"-->
                                <!--                                >-->
                                <!--                                  <option-->
                                <!--                                    v-for="curr in dictionaries.activity-->
                                <!--                                      .currency_types"-->
                                <!--                                    :key="curr.id"-->
                                <!--                                    :value="curr.id"-->
                                <!--                                    >{{ curr.symbol + " " + curr.name }}-->
                                <!--                                  </option>-->
                                <!--                                </select>-->

                                <p></p>

                                <!--                                <select-->
                                <!--                                  class="form-control input-sm"-->
                                <!--                                  v-model="deposit.method_id"-->
                                <!--                                >-->
                                <!--                                  <option :value="null">Select method</option>-->
                                <!--                                  <option-->
                                <!--                                    v-for="method in dictionaries.activity-->
                                <!--                                      .deposit_methods"-->
                                <!--                                    :key="method.id"-->
                                <!--                                    :value="method.id"-->
                                <!--                                    >{{ method.method }}-->
                                <!--                                  </option>-->
                                <!--                                </select>-->
                              </div>
                              <div class="add-tag-menu-item-title">
                                <p
                                  :class="{
                                    errColor: deposit.errors.hasOwnProperty(
                                      'method_id'
                                    )
                                  }"
                                  @click="
                                    [openCustomSelectF5 = !openCustomSelectF5,depMethdsSerch = '']
                                  "
                                >
                                  {{
                                    optionClickedF5 != null &&
                                    !deposit.errors.hasOwnProperty("method_id")
                                      ? optionClickedF5
                                      : "Select method"
                                  }}
                                </p>
                                <input
                                  v-show="openCustomSelectF5"
                                  class="input-standard-for-dep"
                                  type="search"
                                  placeholder="Search Methods"
                                  v-model="depMethdsSerch"
                                  @click="openDepMethdsList = true"
                                  @change="openDepMethdsList = true"
                                />
                                <ul
                                  class="assign-menu-item"
                                  v-for="method in depMethdsSerch.length > 0 || depMethdsSerchResults.length > 0 ? depMethdsSerchResults :   dictionaries.activity
                                    .deposit_methods"
                                  :key="method.id"
                                  :value="method.id"
                                  v-show="openCustomSelectF5"
                                >
                                  <li
                                    @click="
                                      [
                                        (deposit.method_id = method.id),
                                        (openCustomSelectF5 = !openCustomSelectF5),
                                        (optionClickedF5 = method.method),
                                        (deposit.errors = {}),
                                        depMethdsSerch = ''
                                      ]
                                    "
                                  >
                                    {{ method.method }}
                                  </li>
                                </ul>
                              </div>

                              <!--                              <div-->
                              <!--                                class="form-group for-sum"-->
                              <!--                                :class="{-->
                              <!--                                  'has-error': deposit.errors.hasOwnProperty(-->
                              <!--                                    'amount'-->
                              <!--                                  )-->
                              <!--                                }"-->
                              <!--                              >-->
                              <!--                                <input-->

                              <!--                                  type="text"-->
                              <!--                                  class="form-control input-sm sum"-->
                              <!--                                  style="margin-bottom:0;"-->
                              <!--                                  v-model="deposit.amount"-->
                              <!--                                  placeholder="Amount"-->
                              <!--                                />-->

                              <!--                                <p-->
                              <!--                                  v-if="deposit.errors.hasOwnProperty('amount')"-->
                              <!--                                  class="help-block"-->
                              <!--                                >-->
                              <!--                                  &lt;!&ndash;{{ deposit.errors.amount }}&ndash;&gt;-->
                              <!--                                  Amount empty-->
                              <!--                                </p>-->
                              <!--                              </div>-->
                              <p></p>
                              <div
                                class="form-group"
                                :class="{
                                  'has-error': deposit.errors.hasOwnProperty(
                                    'call_broker_at'
                                  )
                                }"
                              >
                                <div
                                  class="date-check-box form-control colored"
                                >
                                  <input
                                    type="checkbox"
                                    value="completed"
                                    id="sc-date-checkbox"
                                    v-model="scDepDateCheckBox"
                                  />
                                  <span class="sc-date-span"
                                    >No Scheduled Call For A Broker
                                  </span>
                                </div>
                              </div>
                              <div
                                class="form-group"
                                :class="{
                                  'has-error': deposit.errors.hasOwnProperty(
                                    'call_broker_at'
                                  )
                                }"
                              >
                                <span
                                  class=""
                                  @click="
                                    [
                                      (hideSecDepCalAfterDateChoosed = !hideSecDepCalAfterDateChoosed),
                                      (deposit.call_broker_at = ''),
                                      (datePickerKey += 1)
                                    ]
                                  "
                                  >{{
                                    createMoment(deposit.call_broker_at) !==
                                    "Invalid date"
                                      ? createMoment(deposit.call_broker_at)
                                      : ""
                                  }}</span
                                >

                                <date-picker
                                  :key="datePickerKey"
                                  :class="{
                                    hideIt: hideSecDepCalAfterDateChoosed
                                  }"
                                  lang="en"
                                  v-model="deposit.call_broker_at"
                                  :first-day-of-week="1"
                                  type="datetime"
                                  :minute-step="1"
                                  placeholder="Scheduled call for a broker"
                                  :time-picker-options="timePickerOptions"
                                  input-class="form-control input-sm"
                                  v-if="!scDepDateCheckBox"
                                  inline
                                  @change="showOrHide"
                                ></date-picker>

                                <p
                                  v-if="
                                    deposit.errors.hasOwnProperty(
                                      'call_broker_at'
                                    )
                                  "
                                  class="help-block"
                                >
                                  Select Scheduled Call Option
                                </p>
                              </div>

                              <textarea
                                class="form-control input-sm comment-box-scheduled  textAreaDp"
                                placeholder="Comment"
                                v-model.trim="deposit.comment"
                                maxlength="160"
                              ></textarea>

                              <span class="text-counter-scheduled"
                                >{{ deposit.comment.length }}/160</span
                              >
                              <p></p>
                            </div>
                          </div>
                          <div v-if="selectedDepMenuTab === 'QS'">
                            <div
                              v-if="deposit.errors.hasOwnProperty('questions')"
                              class="qs-warning"
                            >
                              <span class="haj">Fill All Questions</span>
                            </div>

                            <div v-for="(id, idx) in questLog" :key="id.id">
                              <div
                                class="dep-qs-form"
                                :class="{ 'dep-qs-form-even': idx % 2 === 0 }"
                              >
                                <span
                                  class="quest-line-bold"
                                  :class="{ 'dep-qs-form-even': idx % 2 === 0 }"
                                >
                                  {{ id.question }}
                                </span>
                                <div class="quest-inline">
                                  <client-answer-for-dep
                                    :client="client"
                                    :question-id="id.id"
                                    :send-updated="sendUpdated"
                                    :root="'depForm'"
                                    @updated="updateClients"
                                  ></client-answer-for-dep>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              CheckUserPermission([1, 2, 12]) &&
                                selectedDepMenuTab === 'SUP'
                            "
                          >
                            <div class="table sup-table">
                              <table>
                                <tr>
                                  <td class="sup-question">
                                    <b>Call From Broker </b>
                                  </td>
                                  <td class="sup-answer">
                                    <pre-deposit-answer
                                      :client="client.answers"
                                      :client-id="client.id"
                                      :question-id="1"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-answer>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question"><b>Send Docs</b></td>
                                  <td class="sup-answer">
                                    <pre-deposit-answer
                                      :client="client.answers"
                                      :client-id="client.id"
                                      :question-id="2"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-answer>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question">
                                    <b>Broker Traded</b>
                                  </td>
                                  <td class="sup-answer">
                                    <pre-deposit-answer
                                      :client="client.answers"
                                      :client-id="client.id"
                                      :question-id="3"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-answer>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question">
                                    <b>Do you like the broker</b>
                                  </td>
                                  <td class="sup-answer">
                                    <pre-deposit-answer
                                      :client="client.answers"
                                      :client-id="client.id"
                                      :question-id="4"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-answer>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question">
                                    <b>Do you like our service</b>
                                  </td>
                                  <td class="sup-answer">
                                    <pre-deposit-answer
                                      :client="client.answers"
                                      :client-id="client.id"
                                      :question-id="5"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-answer>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question">
                                    <b>Did you like our agent</b>
                                  </td>
                                  <td class="sup-answer">
                                    <pre-deposit-answer
                                      :client="client.answers"
                                      :client-id="client.id"
                                      :question-id="6"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-answer>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question"><b>Broker</b></td>
                                  <td class="sup-answer">
                                    {{
                                      findBrokerNameByID(deposit.campaign_id)
                                    }}
                                  </td>
                                </tr>
                                <tr
                                  v-if="
                                    findBrokerEmailByID(deposit.campaign_id)
                                  "
                                >
                                  <td class="sup-question"><b>Email</b></td>
                                  <td class="sup-answer">
                                    {{
                                      findBrokerEmailByID(deposit.campaign_id)
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="sup-question">
                                    <b>Contacted by</b>
                                  </td>
                                  <td class="sup-answer">
                                    <!-- TODO:  Need to change from deposit to right data for select-component                         -->
                                    <pre-deposit-select-component
                                      :client-id="client.id"
                                      @updated="$emit('updated')"
                                    ></pre-deposit-select-component>
                                  </td>
                                </tr>

                                <tr>
                                  <td class="sup-question">
                                    <b>Upload File</b>
                                  </td>
                                  <td class="sup-answer">
                                    <pre-deposit-file-upload
                                      :client-id="client"
                                      @updated="$emit('updated')"
                                      :send-updated="sendUpdated"
                                    ></pre-deposit-file-upload>
                                    <i
                                      class="fas fa-trash-alt"
                                      v-if="checkFileUrl(client.id)"
                                      @click="deleteFile(client.id)"
                                    ></i>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>

                          <tag-form-buttons
                            @accepted="saveDepositTag(client)"
                            @cancelled="
                              showForm = false;
                              showDepositForm = false;
                              showDepCal = true;
                              hideSecDepCalAfterDateChoosed = false;
                              deposit.call_broker_at = 'Invalid date';
                              scDepDateCheckBox = true;
                              clearAllFields();
                            "
                          ></tag-form-buttons>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="!showDepositForm">
                    <div
                      v-show="client.is_merged !== 1"
                      class="panel panel-default "
                      v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])"
                    >
                      <div class="panel-heading tr">
                        <h4 class="panel-title">
                          <a
                            @click="
                              [
                                (transInit = false),
                                (showTransferForm = true),
                                (hideTheRestAfterTr = !hideTheRestAfterTr)
                              ]
                            "
                            data-toggle="collapse"
                            data-parent="#accordion"
                            :href="'#collapse1-' + client.id"
                            >TRANSFERS</a
                          >
                          <a
                            @click="
                              [
                                (transInit = false),
                                (showTransferForm = true),
                                (hideTheRestAfterTr = !hideTheRestAfterTr)
                              ]
                            "
                            data-toggle="collapse"
                            data-parent="#accordion"
                            :href="'#collapse1-' + client.id"
                            class="label tag-transfer"
                            >TR</a
                          >
                        </h4>
                      </div>
                      <div
                        :id="'collapse1-' + client.id"
                        class="panel-collapse panel-collapse-tr"
                        v-show="hideTheRestAfterTr"
                      >
                        <div class="panel-body">
                          <div
                            class="dateFromCal"
                            @click="
                              [
                                (showScTrCal = !showScTrCal),
                                (transfer.scheduledCall = ''),
                                (datePickerKey += 1)
                              ]
                            "
                          >
                            <span v-if="transfer.type === 4">
                              {{
                                createMoment(transfer.scheduledCall) !==
                                "Invalid date"
                                  ? createMoment(transfer.scheduledCall)
                                  : "Please Choose Date"
                              }}</span
                            >
                          </div>
                          <div v-if="showTransferForm">
                            <div
                              class="form-group"
                              :class="{
                                'has-error': deposit.errors.hasOwnProperty(
                                  'campaign_id'
                                )
                              }"
                            >
                              <p
                                v-if="
                                  deposit.errors.hasOwnProperty('campaign_id')
                                "
                                class="help-block"
                              >
                                {{ deposit.errors.campaign_id }}
                              </p>
                              <div
                                class="add-tag-menu-item-title defInTr"
                                @click="
                                  showfirstPartTrForm = !showfirstPartTrForm

                                "
                              >
                                {{ choosedTraTo }}
                              </div>
                              <div class="dropdown-divider"></div>
                              <div>
                                <div
                                  v-show="showfirstPartTrForm"
                                  class="panel-body hoverOnTr"
                                  @click="
                                    [
                                      (transfer.type = type.id),
                                      (choosedTraTo = type.name),
                                      (showfirstPartTrForm = false)
                                    ],
                                      getSuggestedUsers(client, type.id)
                                  "
                                  v-for="type in dictionaries.activity
                                    .transfer_types"
                                  :key="type.id"
                                  :value="type.id"
                                >
                                  {{ type.name }}
                                </div>

                                <!--                                <ul-->
                                <!--                                  v-show="showfirstPartTrForm"-->
                                <!--                                  class=" d-m p-xy-8 assignment-dropdown-menu"-->
                                <!--                                >-->
                                <!--                                  <li-->
                                <!--                                    class="choosed-type-tra"-->
                                <!--                                    @click="-->
                                <!--                                      [-->
                                <!--                                        (transfer.type = type.id),-->
                                <!--                                        (choosedTraTo = type.name),-->
                                <!--                                        (showfirstPartTrForm = false)-->
                                <!--                                      ],-->
                                <!--                                        getSuggestedUsers(client, type.id)-->
                                <!--                                    "-->
                                <!--                                    v-for="type in dictionaries.activity-->
                                <!--                                      .transfer_types"-->
                                <!--                                    :key="type.id"-->
                                <!--                                    :value="type.id"-->
                                <!--                                  >-->
                                <!--                                    {{ type.name }}-->
                                <!--                                  </li>-->
                                <!--                                </ul>-->
                              </div>
                            </div>

                            <div
                              class="form-group overH"
                              :class="{
                                'has-error': deposit.errors.hasOwnProperty(
                                  'status'
                                )
                              }"
                            >
                              <p
                                v-if="deposit.errors.hasOwnProperty('status')"
                                class="help-block"
                              >
                                {{ deposit.errors.status }}
                              </p>

                              <!--                              <div-->
                              <!--                                class="add-tag-menu-item-title"-->
                              <!--                                @click="tra_to_visibility = true"-->
                              <!--                              >-->
                              <!--                                {{ transfer.to.user.full_name }}-->
                              <!--                              </div>-->
<!--                              <div-->
<!--                                class="date-box-trans"-->
<!--                                v-if="transfer.type === 4"-->
<!--                              >-->
<!--                                <date-picker-->
<!--                                  :key="datePickerKey"-->
<!--                                  v-show="showScTrCal"-->
<!--                                  v-model="transfer.scheduledCall"-->
<!--                                  :first-day-of-week="1"-->
<!--                                  type="datetime"-->
<!--                                  :minute-step="1"-->
<!--                                  :time-picker-options="timePickerOptions"-->
<!--                                  input-class="form-control input-sm"-->
<!--                                  lang="en"-->
<!--                                  placeholder="Schedule a call date"-->
<!--                                  inline-->
<!--                                  @change="showOrHide"-->
<!--                                ></date-picker>-->
<!--                              </div>-->

                              <div class="dropdown-divider"></div>
                              <input
                                v-if="tra_to_visibility"
                                class="input-standard"
                                type="search"
                                placeholder="Search name"
                                v-model="traToSerchQuery"
                              />
                              <div
                                class="btn-trans-confirm-box"
                                v-if="transfer.type !== null"
                              >
                                <img
                                  class="btn-trans-confirm"
                                  @click.stop="sendTransConfirmReq()"
                                  v-if="!transRequestSent"
                                  src="../../../../../../public/img/icons/question-person.png"
                                  alt=""
                                />
                                <!--                              <button-->
                                <!--                                v-if="!transRequestSent"-->
                                <!--                                @click="sendTransConfirmReq()"-->
                                <!--                                class="btn btn-sm btn-info btn-trans-confirm"-->
                                <!--                              >-->
                                <!--                                Ask VP Sales-->
                                <!--                              </button>-->
                                <span
                                  class="trans-msg"
                                  v-if="
                                    transRequestSent && !transRequestReceived
                                  "
                                >
                                  please wait...</span
                                >
                                <span
                                  class="trans-msg"
                                  v-if="transRequestReceived"
                                  ><span
                                    v-if="
                                      transferConfirmAnswer.conf_to_crm_user_id ===
                                        null
                                    "
                                    >Choose yourself</span
                                  ><span v-else>
                                    choose
                                    {{
                                      findUserNameByID(
                                        transferConfirmAnswer.conf_to_crm_user_id
                                      )
                                    }}</span
                                  ></span
                                >
                              </div>
                              <!--            && !change_the_class_visibility-->
                              <div
                                class="sec_drop_tra_to"
                                v-if="tra_to_visibility"
                              >
                                <span
                                  v-if="
                                    suggestedUsers.length > 0 &&
                                      tra_to_visibility
                                  "
                                  >RECOMMENDED</span
                                >
                                <p></p>
                                <ul
                                  v-if="tra_to_visibility"
                                  class=" d-m p-xy-8 assignment-dropdown-menu"
                                >
                                  <li
                                    v-if="CheckUserPermission([1, 2, 3, 12])"
                                    @click="
                                      [
                                        (transfer.to = {
                                          user: suggested[`data`],
                                          idx: idx + 1
                                        }),
                                        (tra_to_visibility = false),
                                        saveTransfer(client.id),
                                        (hideTheRestAfterTr = false),
                                        (showfirstPartTrForm = true),

                                        transfer.type === 4? openCaComponent(client.id,suggested[`data`].id):''
                                      ]
                                    "
                                    class="choosed-type-tra suggested-users"
                                    v-for="(suggested, idx) in suggestedUsers"
                                    :key="idx"
                                    :value="{
                                      user: suggested[`data`],
                                      idx: idx + 1
                                    }"
                                  >
                                    {{ suggested["data"].full_name }}|
                                    {{ suggested["score"] }}
                                  </li>
                                  <li
                                    v-if="CheckUserPermission([4, 5])"
                                    @click="
                                      [
                                        (transfer.to = {
                                          user: suggested[`data`],
                                          idx: idx + 1
                                        }),
                                        (tra_to_visibility = false),
                                        saveTransfer(client.id),
                                        (hideTheRestAfterTr = false),
                                        (showfirstPartTrForm = true),
                                       transfer.type === 4? openCaComponent(client.id,suggested[`data`].id):''
                                      ]
                                    "
                                    class="choosed-type-tra suggested-users"
                                    v-for="(suggested, idx) in suggestedUsers"
                                    :key="idx"
                                    :value="{
                                      user: suggested[`data`],
                                      idx: idx + 1
                                    }"
                                  >
                                    <!--                                    # +{{ idx }}|-->
                                    {{ suggested["data"].full_name }}
                                  </li>
                                </ul>
                                <span
                                  v-if="
                                    suggestedUsers.length > 0 &&
                                      tra_to_visibility
                                  "
                                >
                                  <hr />
                                  ALL</span
                                >
                                <ul>
                                  <li
                                    class="forAllCli"
                                    @click="
                                      [
                                        (transfer.to = {
                                          user: person,
                                          idx: null
                                        }),
                                        (tra_to_visibility = false),
                                        saveTransfer(client.id),
                                        (hideTheRestAfterTr = false),
                                        (showfirstPartTrForm = true),
                                        transfer.type === 4? openCaComponent(client.id,person.id):''
                                      ]
                                    "
                                    v-for="(person, idx) in FilterUsersRole(
                                      FilterNonActiveUsers(uniqueUsers),
                                      7
                                    )"
                                    :key="idx"
                                    :value="{ user: person, idx: null }"
                                  >
                                    {{ person.full_name }}
                                  </li>
                                </ul>
                                <hr v-if="tra_to_visibility" />
                                <span
                                  v-if="
                                    unSuggestedUsers.length > 0 &&
                                      tra_to_visibility
                                  "
                                  >INADVISABLE</span
                                >
                                <p></p>
                                <ul>
                                  <li
                                    v-if="CheckUserPermission([1, 2, 3, 12])"
                                    class="unsuggested-users"
                                    @click="
                                      [
                                        (transfer.to = {
                                          user: unsuggested[`data`],
                                          idx: -1 - idx
                                        }),
                                        (tra_to_visibility = false),
                                        saveTransfer(client.id),
                                        (hideTheRestAfterTr = false),
                                        (showfirstPartTrForm = true),
                                        transfer.type === 4? openCaComponent(client.id,unsuggested[`data`].id):''
                                      ]
                                    "
                                    v-for="(unsuggested,
                                    idx) in unSuggestedUsers"
                                    :key="idx"
                                    :value="{
                                      user: unsuggested[`data`],
                                      idx: -1 - idx
                                    }"
                                  >
                                    {{ unsuggested["data"].full_name }}|
                                    {{ unsuggested["score"] }}
                                  </li>
                                  <li
                                    v-if="CheckUserPermission([4, 5])"
                                    class="unsuggested-users"
                                    @click="
                                      [
                                        (transfer.to = {
                                          user: unsuggested[`data`],
                                          idx: -1 - idx
                                        }),
                                        (tra_to_visibility = false),
                                        saveTransfer(client.id),
                                        (hideTheRestAfterTr = false),
                                        (showfirstPartTrForm = true),
                                        transfer.type === 4?  openCaComponent(client.id,unsuggested[`data`].id):''
                                      ]
                                    "
                                    v-for="(unsuggested,
                                    idx) in unSuggestedUsers"
                                    :key="idx"
                                    :value="{
                                      user: unsuggested[`data`],
                                      idx: -1 - idx
                                    }"
                                  >
                                    {{ unsuggested["data"].full_name }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-show="!hideTheRestAfterTr">
                      <div
                        v-show="client.is_merged !== 1"
                        class="panel panel-default"
                      >
                        <div
                          class="panel-heading ca"
                          @click="openCaComponent(client.id)"
                        >
                          <h4 class="panel-title">
                            <a
                              data-toggle="collapse"
                              data-parent="#accordion"
                              :href="'#collapse4-' + client.id"
                              >SCHEDULE CALL</a
                            >
                            <!--                            @click="-->
                            <!--                            [-->
                            <!--                            (showScheduleCallForm = true),-->
                            <!--                            (hideTheRestAfterCa = !hideTheRestAfterCa)-->
                            <!--                            ]-->
                            <!--                            "-->
                            <a
                              data-toggle="collapse"
                              data-parent="#accordion"
                              :href="'#collapse4-' + client.id"
                              class="label tag-scheduled-call-newV"
                              >SC</a
                            >
                          </h4>
                        </div>
                        <div
                          :id="'collapse4-' + client.id"
                          class="panel-collapse collapse"
                        >
                          <div class="panel-body">
                            <div
                              class="dateFromCal"
                              @click="
                                [
                                  (showScCal = !showScCal),
                                  (scheduledCall = ''),
                                  (datePickerKey += 1)
                                ]
                              "
                            >
                              {{
                                createMoment(scheduledCall) !== "Invalid date"
                                  ? createMoment(scheduledCall)
                                  : ""
                              }}
                            </div>
                            <div v-if="showScheduleCallForm">
                              <div>
                                <date-picker
                                  :key="datePickerKey"
                                  v-show="!showScCal"
                                  lang="en"
                                  :minute-step="1"
                                  :time-picker-options="timePickerOptions"
                                  type="datetime"
                                  :first-day-of-week="1"
                                  v-model="scheduledCall"
                                  inline
                                  @change="showOrHide"
                                ></date-picker>

                                <div
                                  class="form-group"
                                  :class="{
                                    'has-error':
                                      scheduledCallCommentError.length > 0
                                  }"
                                >
                                  <div>
                                    <div v-show="sCformSecPart">
                                      <input
                                        class="btn dropdown-toggle selection-bar input-sc-status"
                                        type="button"
                                        v-model="scheduledCallStatusText"
                                        @click="
                                          [
                                            (showScOptions = true),
                                            (openSeg = !openSeg)
                                          ]
                                        "
                                      />

                                      <ul
                                        v-show="openSeg"
                                        class="lang-dropdown"
                                      >
                                        <li
                                          @click="
                                            scheduledCallStatus = item;
                                            scheduledCallStatusText = item.type;
                                            showScOptions = false;
                                            openSeg = false;
                                          "
                                          class="add-tag-menu-item"
                                          v-for="item in dictionaries.activity
                                            .scheduled_calls_statuses"
                                          :key="item.id"
                                        >
                                          {{ item.type }}
                                        </li>
                                      </ul>
                                    </div>

                                    <textarea
                                      class="form-control input-sm comment-box-scheduled "
                                      placeholder="Comment"
                                      v-model.trim="scheduledCallComment"
                                      maxlength="160"
                                    ></textarea>
                                    <span class="text-counter-scheduled"
                                      >{{
                                        scheduledCallComment.length
                                      }}/160</span
                                    >
                                    <p
                                      v-if="
                                        scheduledCallCommentError.length > 0
                                      "
                                      class="help-block"
                                    >
                                      {{ scheduledCallCommentError }}
                                    </p>
                                  </div>
                                  <tag-form-buttons
                                    @accepted="
                                      [
                                        saveScheduledCall(client.id),
                                        (hideTheRestAfterCa = false),
                                        (scheduledCallComment = '')
                                      ]
                                    "
                                    @cancelled="
                                      showForm = false;
                                      showScheduleCallForm = false;
                                      hideTheRestAfterCa = false;
                                      sCformSecPart = false;
                                      showScCal = false;
                                      scheduledCallComment = '';

                                      resetAllForms();
                                    "
                                  ></tag-form-buttons>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-show="!hideTheRestAfterCa">
                        <div
                          v-show="client.is_merged !== 1"
                          class="panel panel-default"
                        >
                          <div class="panel-heading ld">
                            <h4 class="panel-title">
                              <a
                                @click="
                                  [
                                    (showLdCal = false),
                                    (showLeadForm = true),
                                    (showFromAfterLd = !showFromAfterLd)
                                  ]
                                "
                                data-toggle="collapse"
                                data-parent="#accordion"
                                :href="'#collapse5-' + client.id"
                                >LEAD</a
                              >
                              <a
                                @click="
                                  [
                                    (showLdCal = false),
                                    (showLeadForm = true),
                                    (showFromAfterLd = !showFromAfterLd)
                                  ]
                                "
                                data-toggle="collapse"
                                data-parent="#accordion"
                                :href="'#collapse5-' + client.id"
                                class="label tag-lead-newV"
                                >LD</a
                              >
                            </h4>
                          </div>
                          <div
                            :id="'collapse5-' + client.id"
                            class="panel-collapse"
                            v-show="showLeadForm"
                          >
                            <div class="panel-body">
                              <!--                              (showLdCal = !showLdCal),-->
                              <!--                              <div-->
                              <!--                                class="dateFromCal"-->
                              <!--                                @click="-->
                              <!--                                  [-->

                              <!--                                    (lead.payment_on = ''),-->
                              <!--                                    (datePickerKey += 1)-->
                              <!--                                  ]-->
                              <!--                                "-->
                              <!--                              >-->
                              <!--                                {{-->
                              <!--                                  createMoment(lead.payment_on) !==-->
                              <!--                                  "Invalid date"-->
                              <!--                                    ? createMoment(lead.payment_on)-->
                              <!--                                    : "" /*now*/-->
                              <!--                                }}-->
                              <!--                              </div>-->
                              <div v-if="showLeadForm">
                                <div
                                  class="form-group"
                                  :class="{
                                    'has-error': lead.errors.hasOwnProperty(
                                      'campaign_id'
                                    )
                                  }"
                                >
                                  <!--                                  <p-->
                                  <!--                                    v-if="-->
                                  <!--                                      lead.errors.hasOwnProperty('campaign_id')-->
                                  <!--                                    "-->
                                  <!--                                    class="help-block"-->
                                  <!--                                  >-->
                                  <!--                                    {{ lead.errors.campaign_id }}-->
                                  <!--                                  </p>-->
                                  <!--                                  <div class="form-group">-->
                                  <!--                                    <date-picker-->
                                  <!--                                      :key="datePickerKey"-->
                                  <!--                                      v-show="showLdCal"-->
                                  <!--                                      v-model="lead.payment_on"-->
                                  <!--                                      :first-day-of-week="1"-->
                                  <!--                                      type="datetime"-->
                                  <!--                                      :minute-step="1"-->
                                  <!--                                      :time-picker-options="timePickerOptions"-->
                                  <!--                                      input-class="form-control input-sm"-->
                                  <!--                                      lang="en"-->
                                  <!--                                      inline-->
                                  <!--                                      @change="showOrHide"-->
                                  <!--                                    ></date-picker>-->
                                  <!--                                  </div>-->
                                  <div v-show="!showLdCal">
                                    <div class="add-tag-menu-item-title">
                                      <p
                                        :class="{
                                          errColor: lead.errors.hasOwnProperty(
                                            'campaign_id'
                                          )
                                        }"
                                        @click="
                                          [openCustomSelectF6 = !openCustomSelectF6,ldCampSerch = '']
                                        "
                                      >
                                        {{
                                          optionClickedF6 != null &&
                                          !lead.errors.hasOwnProperty(
                                            "campaign_id"
                                          )
                                            ? optionClickedF6
                                            : "Select campaign"
                                        }}
                                      </p>
                                      <input
                                        v-show="openCustomSelectF6"
                                        class="input-standard-for-dep"
                                        type="search"
                                        placeholder="Search Campaign"
                                        v-model="ldCampSerch"
                                        @click="openLdCampList = true"
                                        @change="openLdCampList = true"
                                      />
                                      <ul
                                        class="assign-menu-item"
                                        v-for="campaign in ldCampSerch.length > 0 || ldCampSerchResults.length > 0 ? ldCampSerchResults :  FilterNonActiveBrokers()"
                                        :key="campaign.id"
                                        :value="campaign.id"
                                        v-show="openCustomSelectF6"
                                      >
                                        <li
                                          @click="
                                            [
                                              (lead.campaign_id = campaign.id),
                                              (openCustomSelectF6 = !openCustomSelectF6),
                                              (optionClickedF6 = campaign.name),
                                              (lead.errors = {}),
                                              ldCampSerch = ''
                                            ]
                                          "
                                        >
                                          {{ campaign.name }}
                                        </li>
                                      </ul>
                                    </div>
                                    <p></p>

                                    <!--                                    <select-->
                                    <!--                                      class="form-control input-sm"-->
                                    <!--                                      v-model="lead.campaign_id"-->
                                    <!--                                    >-->
                                    <!--                                      <option :value="null"-->
                                    <!--                                        >Select campaign</option-->
                                    <!--                                      >-->
                                    <!--                                      <option-->
                                    <!--                                        v-for="campaign in FilterNonActiveBrokers()"-->
                                    <!--                                        :key="campaign.id"-->
                                    <!--                                        :value="campaign.id"-->
                                    <!--                                        >{{ campaign.name }}-->
                                    <!--                                      </option>-->
                                    <!--                                    </select>-->

                                    <div
                                      class="form-group"
                                      :class="{
                                        'has-error': lead.errors.hasOwnProperty(
                                          'comment'
                                        )
                                      }"
                                    >
                                      <p
                                        v-if="
                                          lead.errors.hasOwnProperty('comment')
                                        "
                                        class="help-block"
                                      >
                                        {{ lead.errors.comment }}
                                      </p>

                                      <textarea
                                        class="form-control input-sm textAreaLd"
                                        placeholder="Comment"
                                        v-model.trim="lead.comment"
                                        maxlength="160"
                                      ></textarea>
                                      <span class="text-counter-lead"
                                        >{{ lead.comment.length }}/160</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <tag-form-buttons
                                  @accepted="saveLeadTag(client.id)"
                                  @cancelled="
                                    showForm = false;
                                    showLeadForm = false;
                                    showLdCal = true;
                                    showFromAfterLd = true;
                                    clearAllFields();
                                  "
                                ></tag-form-buttons>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-show="showFromAfterLd">
                          <div
                            v-show="client.is_merged !== 1"
                            class="panel panel-default"
                          >
                            <div class="panel-heading rf">
                              <h4 class="panel-title">
                                <!--                                (showRfCal = true),-->
                                <a
                                  @click="
                                    [
                                      (showReferralForm = true),
                                      (showRfCal = false),
                                      (showRestAfterRf = !showRestAfterRf)
                                    ]
                                  "
                                  data-toggle="collapse"
                                  data-parent="#accordion"
                                  :href="'#collapse6-' + client.id"
                                  >REFERRAL</a
                                >
                                <a
                                  @click="
                                    [
                                      (showReferralForm = true),
                                      (showRfCal = false),
                                      (showRestAfterRf = !showRestAfterRf)
                                    ]
                                  "
                                  data-toggle="collapse"
                                  data-parent="#accordion"
                                  :href="'#collapse6-' + client.id"
                                  class="label tag-referral-newV"
                                  >RF</a
                                >
                              </h4>
                            </div>
                            <div
                              :id="'collapse6-' + client.id"
                              class="panel-collapse"
                              v-show="showReferralForm"
                            >
                              <div class="panel-body">
                                <!--                                <div-->
                                <!--                                  class="dateFromCal"-->
                                <!--                                  @click="-->
                                <!--                                    [-->
                                <!--                                      // (showRfCal = !showRfCal),-->
                                <!--                                      (referral.payment_on = ''),-->
                                <!--                                      (datePickerKey += 1)-->
                                <!--                                    ]-->
                                <!--                                  "-->
                                <!--                                >-->
                                <!--                                  {{-->
                                <!--                                    createMoment(-->
                                <!--                                      referral.errors.campaign_id-->
                                <!--                                    ) !== "Invalid date"-->
                                <!--                                      ? createMoment(-->
                                <!--                                          referral.errors.campaign_id-->
                                <!--                                        )-->
                                <!--                                      : ""-->
                                <!--                                  }}-->
                                <!--                                </div>-->
                                <div v-if="showReferralForm">
                                  <div
                                    class="form-group"
                                    :class="{
                                      'has-error': referral.errors.hasOwnProperty(
                                        'campaign_id'
                                      )
                                    }"
                                  >
                                    <p
                                      v-if="
                                        referral.errors.hasOwnProperty(
                                          'campaign_id'
                                        )
                                      "
                                      class="help-block"
                                    >
                                      {{ referral.errors.campaign_id }}
                                    </p>
                                    <!--                                    <div class="form-group">-->
                                    <!--                                      <date-picker-->
                                    <!--                                        :key="datePickerKey"-->
                                    <!--                                        v-show="showRfCal"-->
                                    <!--                                        v-model="referral.payment_on"-->
                                    <!--                                        :first-day-of-week="1"-->
                                    <!--                                        type="datetime"-->
                                    <!--                                        :minute-step="1"-->
                                    <!--                                        :time-picker-options="timePickerOptions"-->
                                    <!--                                        input-class="form-control input-sm"-->
                                    <!--                                        lang="en"-->
                                    <!--                                        inline-->
                                    <!--                                        @change="showOrHide"-->
                                    <!--                                      ></date-picker>-->
                                    <!--                                    </div>-->
                                    <div v-show="!showRfCal">
                                      <div class="add-tag-menu-item-title">
                                        <p
                                          :class="{
                                            errColor: referral.errors.hasOwnProperty(
                                              'campaign_id'
                                            )
                                          }"
                                          @click="
                                            [openCustomSelectF7 = !openCustomSelectF7,rfCampSerch = '']
                                          "
                                        >
                                          {{
                                            optionClickedF7 != null &&
                                            !referral.errors.hasOwnProperty(
                                              "campaign_id"
                                            )
                                              ? optionClickedF7
                                              : "Select campaign"
                                          }}
                                        </p>
                                        <input
                                          v-show="openCustomSelectF7"
                                          class="input-standard-for-dep"
                                          type="search"
                                          placeholder="Search Campaign"
                                          v-model="rfCampSerch"
                                          @click="openRfCampList = true"
                                          @change="openRfCampList = true"
                                        />
                                        <ul
                                          class="assign-menu-item"
                                          v-for="campaign in rfCampSerch.length > 0 || rfCampSerchResults.length > 0 ? rfCampSerchResults :   FilterNonActiveBrokers()"
                                          :key="campaign.id"
                                          :value="campaign.id"
                                          v-show="openCustomSelectF7"
                                        >
                                          <li
                                            @click="
                                              [
                                                (referral.campaign_id =
                                                  campaign.id),
                                                (openCustomSelectF7 = !openCustomSelectF7),
                                                (optionClickedF7 =
                                                  campaign.name),
                                                (referral.errors = {})
                                              ]
                                            "
                                          >
                                            {{ campaign.name }}
                                          </li>
                                        </ul>
                                      </div>
                                      <p></p>

                                      <!--                                      <select-->
                                      <!--                                        class="form-control input-sm"-->
                                      <!--                                        v-model="referral.campaign_id"-->
                                      <!--                                      >-->
                                      <!--                                        <option :value="null"-->
                                      <!--                                          >Select Campaign</option-->
                                      <!--                                        >&lt;!&ndash;dictionaries.general.brokers&ndash;&gt;-->
                                      <!--                                        <option-->
                                      <!--                                          v-for="campaign in FilterNonActiveBrokers()"-->
                                      <!--                                          :key="campaign.id"-->
                                      <!--                                          :value="campaign.id"-->
                                      <!--                                          >{{ campaign.name }}-->
                                      <!--                                        </option>-->
                                      <!--                                      </select>-->
                                    </div>

                                    <!--<div
                                      class="form-group"
                                      :class="{ 'has-error': referral.errors.hasOwnProperty('comment') }"
                                    >
                                      <p
                                        v-if="referral.errors.hasOwnProperty('comment')"
                                        class="help-block"
                                      >
                                        {{ referral.errors.comment }}
                                      </p>

                                      <textarea
                                        class="form-control input-sm"
                                        placeholder="Comment"
                                        v-model.trim="referral.comment"
                                        maxlength="160"
                                      ></textarea>
                                      <span class="text-counter-lead"
                                        >{{ referral.comment.length }}/160</span
                                      >
                                    </div>-->

                                    <tag-form-buttons
                                      @accepted="saveReferralTag(client.id)"
                                      @cancelled="
                                        showForm = false;
                                        showReferralForm = false;
                                        // showRfCal = true;
                                        showRestAfterRf = true;
                                        clearAllFields();
                                      "
                                    ></tag-form-buttons>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-show="showRestAfterRf">
                            <div
                              v-show="client.is_merged !== 1"
                              class="panel panel-default"
                              v-if="client.deposits.length === 0"
                            >
                              <div class="panel-heading bn">
                                <h4 class="panel-title">
                                  <a
                                    @click="hideAllAfterBN = !hideAllAfterBN"
                                    data-toggle="collapse"
                                    data-parent="#accordion"
                                    :href="'#collapse12-' + client.id"
                                    >BAD NUMBER</a
                                  >
                                  <a
                                    @click="hideAllAfterBN = !hideAllAfterBN"
                                    data-toggle="collapse"
                                    data-parent="#accordion"
                                    :href="'#collapse12-' + client.id"
                                    class="label tag-bn-newV"
                                    >BN</a
                                  >
                                </h4>
                              </div>
                              <div
                                :id="'collapse12-' + client.id"
                                class="panel-collapse panel-collapse-bn"
                                v-show="hideAllAfterBN"
                              >
                                <div v-if="client.deposits.length === 0">
                                  <input
                                    v-show="hideAllAfterBN"
                                    class="input-standard-bn-lan-ex-ni"
                                    type="search"
                                    placeholder="Search Bad Num Reason "
                                    v-model="bnSerch"
                                    @click="openBnList = true"
                                    @change="openBnList = true"
                                  />
                                  <div
                                    class="panel-body hoverOnBn"
                                    @click="
                                      [applyTag(item), (showForm = false) ,bnSerch = '']
                                    "
                                    v-for="(item, idx) in bnSerch.length > 0 || bnSerchResults.length > 0 ? bnSerchResults:  dictionaries.activity
                                      .bad_number_states"
                                    :key="idx"
                                    :value="item"
                                  >

                                    {{ item.name }}
                                  </div>
                                </div>
                                <div v-else>Forbidden OP</div>
                              </div>
                            </div>
                            <div v-show="!hideAllAfterBN">
                              <div
                                v-show="client.is_merged !== 1"
                                class="panel panel-default "
                              >
                                <div class="panel-heading lng">
                                  <h4
                                    class="panel-title"
                                    @click="[(showLangOptions = true)]"
                                  >
                                    <a
                                      @click="
                                        [
                                          ((showLangOptions = true),
                                          (showFormAfterLng = !showFormAfterLng))
                                        ]
                                      "
                                      data-toggle="collapse"
                                      data-parent="#accordion"
                                      :href="'#collapse8-' + client.id"
                                      >LANGUAGE</a
                                    >
                                    <a
                                      @click="
                                        [
                                          ((showLangOptions = true),
                                          (showFormAfterLng = !showFormAfterLng))
                                        ]
                                      "
                                      data-toggle="collapse"
                                      data-parent="#accordion"
                                      :href="'#collapse8-' + client.id"
                                      class="label tag-language-newV "
                                      >LNG</a
                                    >
                                  </h4>
                                </div>
                                <div
                                  :id="'collapse8-' + client.id"
                                  class="panel-collapse panel-collapse-lang"
                                  v-show="!showFormAfterLng"
                                >
                                  <div class="panel-body">
                                    <div v-if="showLangOptions">
                                      <input
                                        v-show="showLangOptions"
                                        class="input-standard-ni"
                                        type="search"
                                        placeholder="Search Language"
                                        v-model="langSerch"
                                        @click="openLangList = true"
                                        @change="openLangList = true"
                                      />
                                      <div
                                        class="panel-body hoverOnLang"
                                        @click="
                                          [
                                            applyLangTag(item.id, client.id),
                                            (showForm = false),
                                            (showFormAfterLng = true),
                                            (langSerch='')
                                          ]
                                        "
                                        v-for="(item, idx) in langSerch.length > 0 || langSerchResults.length > 0 ? langSerchResults :  dictionaries
                                          .general.languages"
                                        :key="idx"
                                        :value="item"
                                      >
                                        {{ item.name }}
                                      </div>

                                      <!--                                      <ul class="lang-dropdown">-->
                                      <!--                                        <li-->
                                      <!--                                          @click="-->
                                      <!--                                            [-->
                                      <!--                                              applyLangTag(item.id, client.id),-->
                                      <!--                                              (showForm = false),-->
                                      <!--                                              (showFormAfterLng = true)-->
                                      <!--                                            ]-->
                                      <!--                                          "-->
                                      <!--                                          class="add-tag-menu-item"-->
                                      <!--                                          v-for="item in dictionaries.general-->
                                      <!--                                            .languages"-->
                                      <!--                                          :key="item.id"-->
                                      <!--                                        >-->
                                      <!--                                          {{ item.name }}-->
                                      <!--                                        </li>-->
                                      <!--                                      </ul>-->
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-show="showFormAfterLng">
                                <div
                                  v-show="client.is_merged !== 1"
                                  class="panel panel-default "
                                >
                                  <div class="panel-heading com">
                                    <h4
                                      class="panel-title"
                                      @click="[(showCommForm = true)]"
                                    >
                                      <a
                                        @click="
                                          [
                                            ((showCommForm = true),
                                            (showFormAfterCom = !showFormAfterCom))
                                          ]
                                        "
                                        data-toggle="collapse"
                                        data-parent="#accordion"
                                        :href="'#collapse10-' + client.id"
                                        class=""
                                        > EXTRA TAG</a
                                      >
                                      <a
                                        @click="
                                          [
                                            ((showCommForm = true),
                                            (showFormAfterCom = !showFormAfterCom))
                                          ]
                                        "
                                        data-toggle="collapse"
                                        data-parent="#accordion"
                                        :href="'#collapse10-' + client.id"
                                        class="label tag-com-newV "
                                        >TAG</a
                                      >
                                    </h4>
                                  </div>
                                  <div
                                    :id="'collapse10-' + client.id"
                                    class="panel-collapse for-com"
                                    v-show="showCommForm"
                                  >
                                    <div :class="{ forSkype: openSkypeEdit }">
                                      <div v-if="showCommForm || editSkype">
                                        <div
                                          v-if="openSkypeEdit"
                                          :class="{
                                            'has-error': deposit.errors.hasOwnProperty(
                                              'status'
                                            )
                                          }"
                                        >
                                          <!--                          <p-->
                                          <!--                            v-if="deposit.errors.hasOwnProperty('status')"-->
                                          <!--                            class="help-block"-->
                                          <!--                          >-->
                                          <!--                            {{ deposit.errors.status }}-->
                                          <!--                          </p>-->
                                          <!--                          <p>Add New Client Skype:</p>-->
                                          <!--                          <input-->
                                          <!--                            max="40"-->
                                          <!--                            type="search"-->
                                          <!--                            placeholder="Skype Username"-->
                                          <!--                            v-model="communication.contacted_in"-->
                                          <!--                          />-->
                                          <!--                          <span class="text-counter-scheduled"-->
                                          <!--                            >{{-->
                                          <!--                              communication.contacted_in === null-->
                                          <!--                                ? "0"-->
                                          <!--                                : communication.contacted_in.length-->
                                          <!--                            }}/40</span-->
                                          <!--                          >-->
                                          <p
                                            v-if="
                                              deposit.errors.hasOwnProperty(
                                                'status'
                                              )
                                            "
                                            class="help-block"
                                          >
                                            {{ deposit.errors.status }}
                                          </p>
                                          <p>Add New Client Skype:</p>
                                          <input
                                            max="40"
                                            type="search"
                                            placeholder="Skype Username"
                                            v-model="communication.contacted_in"
                                          />
                                          <span class="text-counter-scheduled"
                                            >{{
                                              communication.contacted_in ===
                                              null
                                                ? "0"
                                                : communication.contacted_in
                                                    .length
                                            }}/40</span
                                          >

                                          <br />
                                          <tag-form-buttons
                                            @accepted="addCommunication"
                                            @cancelled="
                                              [
                                                resetAllForms(),
                                                clearAllFields()
                                              ]
                                            "
                                          ></tag-form-buttons>
                                        </div>
                                      </div>
                                    </div>
                                    <input
                                      v-show="!showFormAfterCom"
                                      class="input-standard-ni"
                                      type="search"
                                      placeholder="Search Extra Tab"
                                      v-model="extraSerch"
                                      @click="openExtraList = true"
                                      @change="openExtraList = true"
                                    />
                                    <div
                                      class="panel-body hoverOnComm"
                                      @click="
                                        [
                                          saveCommunication(item),
                                          (showFormAfterCom = true),
                                          (extraSerch = '')
                                        ]
                                      "
                                      v-for="(item, idx) in extraSerch.length > 0 || extraSerchResults.length >0 ? extraSerchResults : dictionaries
                                        .activity.communication_types"
                                      :key="idx"
                                      :value="item"
                                    >
                                      {{ item.name }}
                                    </div>
                                    <!--                                    <ul class="lang-dropdown">-->
                                    <!--                                      <li-->
                                    <!--                                        class="add-tag-menu-item"-->
                                    <!--                                        @click="-->
                                    <!--                                          [-->
                                    <!--                                            saveCommunication(item),-->
                                    <!--                                            (showFormAfterCom = true)-->
                                    <!--                                          ]-->
                                    <!--                                        "-->
                                    <!--                                        v-for="(item, idx) in dictionaries-->
                                    <!--                                          .activity.communication_types"-->
                                    <!--                                        :key="idx"-->
                                    <!--                                        :value="item"-->
                                    <!--                                      >-->
                                    <!--                                        {{ item.name }}-->
                                    <!--                                      </li>-->
                                    <!--                                    </ul>-->
                                  </div>
                                </div>
                                <div v-show="showFormAfterCom">
                                  <div
                                    v-show="client.is_merged !== 1"
                                    class="panel panel-default "
                                  >
                                    <div class="panel-heading ni">
                                      <h4 class="panel-title">
                                        <a
                                          @click="
                                            showFormAfterNi = !showFormAfterNi
                                          "
                                          data-toggle="collapse"
                                          data-parent="#accordion"
                                          :href="'#collapse11-' + client.id"
                                          >NOT INTERESTED</a
                                        >
                                        <a
                                          @click="
                                            showFormAfterNi = !showFormAfterNi
                                          "
                                          data-toggle="collapse"
                                          data-parent="#accordion"
                                          :href="'#collapse11-' + client.id"
                                          class="label tag-ni-newV "
                                          >NI</a
                                        >
                                      </h4>
                                    </div>
                                    <div
                                      :id="'collapse11-' + client.id"
                                      class="panel-collapse panel-collapse-ni"
                                      v-show="!showFormAfterNi"
                                    >
                                      <input
                                        v-show="!showFormAfterNi"
                                        class="input-standard-ni"
                                        type="search"
                                        placeholder="Search Not In Reason"
                                        v-model="niSerch"
                                        @click="openNiList = true"
                                        @change="openNiList = true"
                                      />
                                      <div
                                        class="panel-body hoverOnNi"
                                        @click="
                                          [
                                            applyTag(item),
                                            (showForm = false),
                                            (showFormAfterNi = true),
                                            (niSerch = '')
                                          ]
                                        "
                                        v-for="(item, idx) in niSerch.length > 0 || niSerchResults.length > 0 ? niSerchResults : dictionaries
                                          .activity.not_int_states"
                                        :key="idx"
                                        :value="item"
                                      >
                                        {{ item.name }}
                                      </div>
                                      <!--                                      <ul class="lang-dropdown">-->
                                      <!--                                        <li-->
                                      <!--                                          class="add-tag-menu-item"-->
                                      <!--                                          @click="-->
                                      <!--                                            [-->
                                      <!--                                              applyTag(item),-->
                                      <!--                                              (showForm = false),-->
                                      <!--                                              (showFormAfterNi = true)-->
                                      <!--                                            ]-->
                                      <!--                                          "-->
                                      <!--                                          v-for="(item, idx) in dictionaries-->
                                      <!--                                            .activity.not_int_states"-->
                                      <!--                                          :key="idx"-->
                                      <!--                                          :value="item"-->
                                      <!--                                        >-->
                                      <!--                                          {{ item.name }}-->
                                      <!--                                        </li>-->
                                      <!--                                      </ul>-->
                                    </div>
                                  </div>
                                  <div v-show="showFormAfterNi">
                                    <div
                                      v-show="client.is_merged !== 1"
                                      class="panel panel-default "
                                    >
                                      <div class="panel-heading p2">
                                        <h4 class="panel-title">
                                          <a
                                            @click="
                                              [
                                                applyTag({
                                                  id: 0,
                                                  type: 'TAG_NA'
                                                }),
                                                (showForm = false)
                                              ]
                                            "
                                            data-parent="#accordion"
                                            :href="'#collapse2-' + client.id"
                                            >NO ANSWER</a
                                          >
                                          <a
                                            @click="
                                              [
                                                applyTag({
                                                  id: 0,
                                                  type: 'TAG_NA'
                                                }),
                                                (showForm = false)
                                              ]
                                            "
                                            data-toggle="collapse"
                                            data-parent="#accordion"
                                            :href="'#collapse2-' + client.id"
                                            class="label tag-na-newV naOnly"
                                            >NA</a
                                          >
                                          <span class="spacerIng"></span>
                                          <a
                                            @click="
                                              [
                                                applyTag({
                                                  id: 0,
                                                  type: 'TAG_NA_VM'
                                                }),
                                                (showForm = false)
                                              ]
                                            "
                                            data-toggle="collapse"
                                            data-parent="#accordion"
                                            :href="'#collapse3-' + client.id"
                                            class="label tag-na-newV"
                                            >NAV</a
                                          >
                                        </h4>
                                      </div>
                                      <div
                                        :id="'collapse2-' + client.id"
                                        class="panel-collapse collapse"
                                      >
                                        <div class="panel-body"></div>
                                      </div>
                                    </div>
                                    <!--                                    <div class="panel panel-default ">-->
                                    <!--                                      <div class="panel-heading p3">-->
                                    <!--                                        <h4 class="panel-title">-->
                                    <!--                                          <a-->
                                    <!--                                            @click="-->
                                    <!--                                              [-->
                                    <!--                                                applyTag({-->
                                    <!--                                                  id: 0,-->
                                    <!--                                                  type: 'TAG_NA_VM'-->
                                    <!--                                                }),-->
                                    <!--                                                (showForm = false)-->
                                    <!--                                              ]-->
                                    <!--                                            "-->
                                    <!--                                            data-parent="#accordion"-->
                                    <!--                                            :href="'#collapse3-' + client.id"-->
                                    <!--                                            >NA VOICE MAIL</a-->
                                    <!--                                          >-->
                                    <!--                                          <a-->
                                    <!--                                            @click="-->
                                    <!--                                              [-->
                                    <!--                                                applyTag({-->
                                    <!--                                                  id: 0,-->
                                    <!--                                                  type: 'TAG_NA_VM'-->
                                    <!--                                                }),-->
                                    <!--                                                (showForm = false)-->
                                    <!--                                              ]-->
                                    <!--                                            "-->
                                    <!--                                            data-toggle="collapse"-->
                                    <!--                                            data-parent="#accordion"-->
                                    <!--                                            :href="'#collapse3-' + client.id"-->
                                    <!--                                            class="label tag-na-newV"-->
                                    <!--                                            >NAV</a-->
                                    <!--                                          >-->
                                    <!--                                        </h4>-->
                                    <!--                                      </div>-->
                                    <!--                                      <div-->
                                    <!--                                        :id="'collapse3-' + client.id"-->
                                    <!--                                        class="panel-collapse collapse"-->
                                    <!--                                      >-->
                                    <!--                                        <div class="panel-body">.</div>-->
                                    <!--                                      </div>-->
                                    <!--                                    </div>-->
                                    <div
                                      v-show="client.is_merged !== 1"
                                      class="panel panel-default "
                                      v-if="client.deposits.length > 0"
                                    >
                                      <div class="panel-heading end">
                                        <h4 class="panel-title ">
                                          <a
                                            @click="
                                              [
                                                applyTagEnded(),
                                                (showForm = false)
                                              ]
                                            "
                                            data-toggle="collapse"
                                            data-parent="#accordion"
                                            :href="'#collapse12-' + client.id"
                                            >ENDED</a
                                          >
                                          <a
                                            @click="
                                              [
                                                applyTagEnded(),
                                                (showForm = false)
                                              ]
                                            "
                                            data-toggle="collapse"
                                            data-parent="#accordion"
                                            :href="'#collapse12-' + client.id"
                                            class="label tag-endedNew"
                                            >EN</a
                                          >
                                        </h4>
                                      </div>
                                      <div
                                        :id="'collapse12-' + client.id"
                                        class="panel-collapse collapse"
                                      >
                                        <div class="panel-body">
                                          <!--                                          <ended-->
                                          <!--                                                  :client="client"-->
                                          <!--                                                  :show-remove="editTags"-->
                                          <!--                                                  @delete="removeTag('UNTAG_ENDED', client.id)"-->
                                          <!--                                          >-->
                                          <!--                                          </ended>-->
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                      <div
                                        class="panel panel-default"
                                        v-if="
                                          CheckUserPermission([
                                            1,
                                            2,
                                            3,
                                            4,
                                            12
                                          ]) &&
                                            editTags === false &&
                                            (client.bad_number_state_id !==
                                              null ||
                                              client.not_interested_state_id !==
                                                null ||
                                              client.scheduled_calls.length >
                                                0 ||
                                              client.na.length > 0 ||
                                              client.leads.length > 0 ||
                                              client.deposits.length > 0 ||
                                              client.communications.length >
                                                0 ||
                                              client.referrals.length > 0 ||
                                              client.waiting === 1 ||
                                              client.transfers.length > 0 ||
                                              (client.language_id &&
                                                client.language !== null))
                                        "
                                      >
                                        <div class="panel-heading">
                                          <h4 class="panel-title">
                                            <i
                                              class="far fa-edit"
                                              data-toggle="collapse"
                                              data-parent="#accordion"
                                              :href="'#collapse9-' + client.id"
                                              @click="[(editTags = true)]"
                                            ></i>
                                            <!--                                          <a-->
                                            <!--                                            data-toggle="collapse"-->
                                            <!--                                            data-parent="#accordion"-->
                                            <!--                                            :href="'#collapse9-' + client.id"-->
                                            <!--                                            @click="[(editTags = true)]"-->
                                            <!--                                            >EDIT TAGS</a-->
                                            <!--                                          >-->
                                            <!--                                          <a-->
                                            <!--                                            @click="[(editTags = true)]"-->
                                            <!--                                            data-toggle="collapse"-->
                                            <!--                                            data-parent="#accordion"-->
                                            <!--                                            :href="'#collapse9-' + client.id"-->
                                            <!--                                            class="label tag-edit-newV"-->
                                            <!--                                            >EDIT</a-->
                                            <!--                                          >-->
                                            <a
                                              v-show="editTags"
                                              class="add-tag-menu-item"
                                            >
                                              <span
                                                class="cancel-edit-menu-item"
                                                @click="editTags = false"
                                                >Cancel Edit
                                                <span
                                                  class="fa fa-close remove-tag-icon"
                                                ></span
                                              ></span>
                                            </a>
                                          </h4>
                                        </div>
                                        <div
                                          :id="'collapse9-' + client.id"
                                          class="panel-collapse collapse"
                                        >
                                          <div class="panel-body">.</div>
                                        </div>
                                      </div>
                                      <div
                                        class="panel panel-default"
                                        v-if="
                                          CheckUserPermission([
                                            1,
                                            2,
                                            3,
                                            4,
                                            12
                                          ]) &&
                                            editTags === true &&
                                            (client.bad_number_state_id !==
                                              null ||
                                              client.not_interested_state_id !==
                                                null ||
                                              client.scheduled_calls.length >
                                                0 ||
                                              client.na.length > 0 ||
                                              client.leads.length > 0 ||
                                              client.deposits.length > 0 ||
                                              client.communications.length >
                                                0 ||
                                              client.referrals.length > 0 ||
                                              client.waiting === 1 ||
                                              client.transfers.length > 0 ||
                                              (client.language_id &&
                                                client.language !== null))
                                        "
                                      >
                                        <div class="panel-heading">
                                          <h4 class="panel-title">
                                            <a
                                              v-show="editTags"
                                              class="add-tag-menu-item"
                                            >
                                              <span
                                                class="cancel-edit-menu-item"
                                                @click="editTags = false"
                                                >Cancel Edit
                                                <span
                                                  class="fa fa-close remove-tag-icon"
                                                ></span
                                              ></span>
                                            </a>
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--    /////////////////////////////////////////////////////////START TABLE TAGS/////////////////////////////////////////////////////////////////-->
    <!--    <div v-if="showTags">-->
    <!--Status Tags-->
    <!--    slide-->
    <div
      v-if="showTags"
      :id="'btnCarousel' + client.id"
      class="carousel  carousel-override"
      data-ride="carousel"
      data-interval="false"
    >
      <div class="carousel-inner">
        <div class="item active">
          <!--          <div-->
          <!--            class="label tag-scheduled-call table-tag-content fake-tag "-->
          <!--            v-if="SCTimer.hasOwnProperty(client.id)"-->
          <!--          >-->
          <!--&lt;!&ndash;            <span>&ndash;&gt;-->
          <!--&lt;!&ndash;              <i class="fas fa-hourglass-start"></i> &nbsp; &nbsp; SC&ndash;&gt;-->
          <!--&lt;!&ndash;            </span>&ndash;&gt;-->
          <!--            <div class="tag-block">-->
          <!--              <div class="tag-wrapper">-->
          <!--                <span class="label tag-scheduled-call table-tag-content">-->
          <!--                  <span class="fake-sand-clock blinking"><i class="fas fa-hourglass-start"></i></span>-->
          <!--                  <span class="fake-sc-date">{{formatDateFakeTag(newSC.call_scheduled_on) }}</span>-->
          <!--                </span>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="tag-block " v-for="item in componentNames" :key="item.id">
            <component
              :list="item.data"
              :na-count="item.na_count"
              :deposits="item.data"
              :answers="item.answers"
              :answers-log="item.answers_log"
              :log="item.log"
              :country="item.country"
              :status-list="item.availableStatuses"
              :client="item.data"
              :client-full-obj="client"
              :client-data="item.client_data"
              :client_dep="item.client_dep"
              :call="item.data"
              :leads="item.data"
              :referrals="item.data"
              :transfers="item.data"
              @delete="removeTag(item.rm, client.id, item.tagIdNum)"
              @deleteFromAct="removeTagFromAct"
              @cancelAssign="cancelAssignTimers(item.id, client.id)"
              @updated="updateDepStat"
              @origin="showOriginClient"
              @merged="showMergedClient"
              @task="addNewTask"
              :show-remove="editTags"
              :is="item.name"
              :initiated-filtering="item.initiatedFiltering"
              :query-object="item.queryObject"
              :send-updated="sendUpdated"
              @updatedFromScTag="updateClients"
            ></component>
          </div>
        </div>
        <div
          v-if="
            client.ended ||
              client.waiting ||
              client.language_id ||
              client.language ||
              client.tech_logs.length > 0 ||
              client.communications.length > 0 ||
              client.clients_merged.length > 0 ||
              client.comments.length > 0
          "
          class="item"
        >
          <ended
            :client="client"
            :show-remove="editTags"
            @delete="removeTag('UNTAG_ENDED', client.id)"
          >
          </ended>

          <language
            :client="client"
            :show-remove="editTags"
            @delete="removeTag('UNTAG_LANGUAGE', client.id)"
          ></language>
          <communications
            v-if="client.communications.length"
            :list="client.communications"
            :show-remove="editTags"
            @editSkype="openEditSkype"
            @delete="removeCommTag"
          ></communications>

          <Merged v-if="!CheckUserPermission([7])" :client="client" @merged="showMergedClient"></Merged>

          <client-activity-log
            v-if="client.tech_logs.length &&  !CheckUserPermission([7]) "
            :list="client.tech_logs"
          ></client-activity-log>
        </div>
      </div>

      <!-- Left and right controls -->
      <!--        <a-->
      <!--          class="left carousel-control"-->
      <!--          :href="'#btnCarousel' + client.id"-->
      <!--          data-slide="prev"-->
      <!--        >-->
      <!--          <i class="fas fa-angle-left"></i>-->
      <!--        </a>-->
      <a
        v-if="
          client.ended ||
            client.waiting ||
            client.language_id ||
            client.language ||
            client.tech_logs.length > 0 ||
            client.communications.length > 0 ||
            client.clients_merged.length > 0
        "
        class="right carousel-control"
        :href="'#btnCarousel' + client.id"
        data-slide="next"
      >
        <i class="fas fa-angle-right"></i>
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Communications from "./tags/Communications";
import ClientActivityLog from "./tags/ClientActivityLog";
import IsNewOrActive from "./tags/IsNewOrActive";
import apiClientCreator from "../../../../../helpers/api/request";
import DatePicker from "vue2-datepicker";
import ScheduledCall from "./tags/ScheduledCall";
import Leads from "./tags/Leads";
import Referral from "./tags/Referral";
import Deposits from "./tags/Deposits";
import Na from "./tags/Na";
import BN from "./tags/BN";
import NI from "./tags/NI";
import Language from "./tags/Language";
//import Waiting from "./tags/Waiting";
import Merged from "./tags/Merged";
//import CommentTag from "./tags/Comment";
import Transfer from "./tags/Transfer";
import Ended from "./tags/Ended";
import TagFormButtons from "./tags/TagFormButtons";
import DotIndicator from "../components/questioner/DotIndicator.component";
import Loader from "../../../../../main/misc.main/loader/Loader";
import ClientAnswerForDep from "../components/questioner/ClientAnswerForDep.component";
// import DepositAnswer from "./support_deposits_questioner/DepositAnswer.component";
import PreDepositAnswer from "./support_deposits_questioner/PreDepositAnswer.component";
import PreDepositFileUpload from "./support_deposits_questioner/PreDepositFileUpload.component";
import vClickOutside from "v-click-outside";
import { addSkype, updateSkype, assignmentUnTag } from "../api/tags.api";
import { tagTypes } from "../constants/TagTypes";
import { tagSearchList } from "../constants/TagSearchList";
import { Globals } from "../../../../../global_constants/constants";
import UsersActiveScope from "../mixins/UsersActiveScope";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import BrokersActiveScope from "../mixins/BrokersActiveScope";
import SelectComponent from "./tags/SelectComponent";
import PreDepositSelectComponent from "./tags/PreDepositSelectComponent";
import SocketEndpoints from "../../../../../mixins/system/SocketEndpoints";
import UserRoleScope from "../mixins/UserRoleScope";
import $ from "jquery";
export default {
  name: "client-tags",

  components: {
    PreDepositFileUpload,
    Loader,
    Referral,
    Communications,
    ClientActivityLog,
    IsNewOrActive,
    DatePicker,
    ScheduledCall,
    Leads,
    Deposits,
    Na,
    BN,
    NI,
    Language,
    //Waiting,
    Transfer,
    Ended,
    TagFormButtons,
    DotIndicator,
    //CommentTag,
    Merged,
    ClientAnswerForDep,
    // DepositAnswer,
    PreDepositAnswer,
    SelectComponent,
    PreDepositSelectComponent
  },
  mixins: [
    UsersActiveScope,
    BrokersActiveScope,
    UsersPermissionCheck,
    UserRoleScope,
    SocketEndpoints
  ],
  props: {
    client: {
      type: Object,
      required: true
    },
    tabAlias: {
      type: String,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      required: true
    },
    showTags: {
      type: Boolean,
      default: () => true
    },
    selectedMainTab: {
      type: String
    },
    selectedTab: {
      type: String
    },
    selectedTagToFilter: {
      type: String
    },
    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    },
    openSchedualerObj: {
      type: Object
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("main", ["showVikiMsg", "updateDepCharts"]),
    ...mapGetters("clients", ["timeStart"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "transferConfirmAnswer",
      "loading",
      "timer",
      "BNTimer",
      "NITimer",
      "SCTimer",
      "newSC",
      "clearClientTags",
      "requestForDate"
    ])
  },
  data() {
    return {
      selectedTagMenuTab: "MAIN",
      tagMenuTabs: [
        {
          id: 6,
          name: "Comm",
          alias: "COMM"
        },
        {
          id: 5,
          name: "Process",
          alias: "PROCESS"
        },
        {
          id: 4,
          name: "LRD",
          alias: "LRD"
        },
        {
          id: 3,
          name: "BN",
          alias: "BN"
        },
        {
          id: 2,
          name: "NI",
          alias: "NI"
        },
        {
          id: 1,
          name: "Main",
          alias: "MAIN"
        }
      ],
      depMenuTabs: [
        {
          id: 1,
          name: "MAIN",
          alias: "MAIN"
        },
        {
          id: 2,
          name: "QUESTIONS",
          alias: "QS"
        },
        {
          id: 3,
          name: "SUPPORT",
          alias: "SUP"
        }
      ],
      selectedDepMenuTab: "MAIN",
      lockTagBtn: false,
      onGroupTagging: false,
      timeouts: [],
      componentNames: [],
      searchTagQuery: "",
      result: [],
      showResults: false,
      tagsSearchList: [],
      showLangOptions: false,
      showForm: false,
      showNacMenu: false,
      selectedTag: {
        /*                    type: null,
                            id: null*/
      },
      redTraffic: false,
      greenTraffic: false,
      yellowTraffic: false,
      componentKey: 0,
      showScheduleCallForm: false,
      scheduledCall: moment(),
      scheduledCallComment: "",
      scheduledCallCommentError: "",
      scheduledCallStatus: {},
      //  scheduledCallStatus: null, //TODO: ??
      scheduledCallStatusText: "Select reason/status",
      showScOptions: false,

      showPrOptions: false,
      scheduledCallPriority: null,
      scheduledCallPriorityTitle: "Select Priority",

      showLeadForm: false,
      showReferralForm: false,
      showTransferForm: false,
      showCommForm: false,
      editSkype: false,
      editTags: false,
      scDepDateCheckBox: true,

      ///////////////////////////
      transRequestSent: false,
      transRequestReceived: false,
      transInit: false,
      //////////////////////////

      untagType: null,

      lead: {
        comment: "",
        payment_on: null,
        campaign_id: null,

        errors: {}
      },
      referral: {
        comment: "",
        payment_on: null,
        campaign_id: null,

        errors: {}
      },

      questLog: [
        {
          id: 1,
          question: "Occupation"
        },
        {
          id: 2,
          question: "What Signals?"
        },
        {
          id: 3,
          question: "Trading Time"
        },
        {
          id: 4,
          question: "Invested So Far"
        },
        {
          id: 5,
          question: "How Much Profit Expected?"
        },
        {
          id: 6,
          question: "Plan To Invest?"
        },
        {
          id: 7,
          question: "Amount Of Broker Or Names"
        },
        {
          id: 8,
          question: "Amount Of Signals?"
        },
        {
          id: 9,
          question: "Reason for trading"
        },
        {
          id: 10,
          question: "Originaly From"
        },
        {
          id: 11,
          question: "Age"
        }
      ],
      transfer: {
        type: null,
        // to: null,
        to: { user: { full_name: " " }, idx: null },
        scheduledCall: null,
        errors: {}
      },

      communication: {
        type: null,
        contacted_in: null
      },
      showDepositForm: false,

      deposit: {
        availableStatuses: [
          "CHECK",
          "TRADED",
          "DONE",
          "REMOVED",
          "PAYED",
          "CC-DECLINE"
        ],

        errors: {},

        campaign_id: null,
        amount: 250,
        currency_id: 1,
        method_id: null,
        status_id: null,
        comment: "",

        //Manager Manual deposit assign
        dep_date: null,
        user_id: null,

        call_broker_at: null
      },

      timePickerOptions: {
        start: "09:00",
        step: "00:15",
        end: "23:45"
      },

      suggestedUsers: [],
      unSuggestedUsers: [],
      uniqueUsers: [],
      tra_to_visibility: true,
      // change_the_class_visibility: true,
      choosedType: "Selected Transfer Type",
      choosedTraTo: "Transfer Client To",
      traToSerchQuery: "",
      searchRes: null,
      choosedFromSearchR: null,
      openMoreTagsMenu: false,
      showExtra: false,
      openSkypeEdit: false,
      openSeg: false,
      showDepCal: false,
      showfirstPartTrForm: true,
      hideTheRestAfterTr: false,
      hideTheRestAfterCa: false,
      sCformSecPart: false,
      showScCal: false,
      showLdCal: true,
      showFromAfterLd: true,
      showRfCal: false,
      showRestAfterRf: true,
      showFormAfterCom: true,
      showFormAfterNi: true,
      showFormAfterLng: true,
      hideAllAfterBN: false,
      hideSecDepCalAfterDateChoosed: false,
      showScTrCal: true,
      datePickerKey: 1,
      plusHovered: false,
      openCustomSelectF1: false,
      openCustomSelectF2: false,
      openCustomSelectF3: false,
      openCustomSelectF4: false,
      openCustomSelectF5: false,
      openCustomSelectF6: false,
      openCustomSelectF7: false,
      optionClicked: null,
      optionClickedF1: null,
      optionClickedF2: null,
      optionClickedF3: null,
      optionClickedF4: null,
      optionClickedF5: null,
      optionClickedF6: null,
      optionClickedF7: null,
      textOrDate: "Choose date From Main Cal ",
      depositDate: false,
      newDate: null,
      newHours: null,
      assignmentGroupIdName: null,
      campaignSerch:"",
      depForSerch:"",
      depStatSerch:"",
      depMethdsSerch:"",
      ldCampSerch:"",
      rfCampSerch:"",
      bnSerch:"",
      langSerch:"",
      extraSerch: "",
      niSerch:"",
      openCampaignList:false,
      openDepStatList:false,
      openDepForList:false,
      openDepMethdsList:false,
      openLdCampList:false,
      openRfCampList:false,
      openBnList:false,
      openLangList:false,
      openExtraList:false,
      openNiList:false,
      campaignSerchResults:[],
      depForSerchResults:[],
      depStatSerchResults:[],
      depMethdsSerchResults:[],
      ldCampSerchResults:[],
      rfCampSerchResults:[],
      bnSerchResults:[],
      langSerchResults:[],
      extraSerchResults:[],
      niSerchResults:[]

      /*      now:moment().format("HH:mm DD/MM/YY ")*/
      // showSearchInp: false,

      // traSearch:''
    };
  },
  mounted() {
    $(this.$el.querySelector(".special-dropdown")).on("hide.bs.dropdown", function(e) {
      e.preventDefault();
    });
    // Prevent accordion <a href="#collapseX"> from changing the URL
    this.$el.addEventListener("click", function(e) {
      const a = e.target.closest('a[data-toggle="collapse"]');
      if (a) e.preventDefault();
    }, true);
    this.measureLen();
    this.checkHowMatchKids();
    if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
      this.showDepCal = true;
    }
  },
  watch: {
    niSerch:function(){
      this.filterNiSerch(this.niSerch,this.dictionaries
        .activity.not_int_states)
    },
    extraSerch:function(){
      this.filterExtraSerch(this.extraSerch,this.dictionaries
        .activity.communication_types)
    },
    langSerch:function(){
      this.filterLangSerch(this.langSerch,this.dictionaries
        .general.languages)
    },
    bnSerch:function(){
      this.filterbnSerch(this.bnSerch,this.dictionaries.activity
        .bad_number_states)
    },
    rfCampSerch:function(){
      this.filterRfCamp(this.rfCampSerch,this.FilterNonActiveBrokers())
    },
    ldCampSerch:function(){
      this.filterldCamp(this.ldCampSerch,this.FilterNonActiveBrokers())
    },
    depMethdsSerch:function(){
      this.filterDepMethdsSerch(this.depMethdsSerch,this.checkPrivileges(this.dictionaries.activity
        .deposit_methods))

    },
    depStatSerch:function(){
      this.filterDepStatSerch(this.depStatSerch,this.checkPrivileges(this.dictionaries.activity.client_deposit_types))
    },
    campaignSerch: function(){
      this.filterCampsForDep(this.campaignSerch,this.filterExistingBroker(this.FilterNonActiveBrokers()))
    },
    depForSerch:function(){
      this.filterDepFor(this.depForSerch,this.salesPersonList)
    },
    "openSchedualerObj.clientId": function() {
      this.showForm = true;
    },
    requestForDate: function() {
      // if (this.requestForDate.time != null) {
      //   this.textOrDate =
      //     'please choose time'
      // }
      if (this.requestForDate.date != null) {
        $(".for-un-closing").css("display", "block");
        this.textOrDate =
          this.requestForDate.time != undefined
            ? this.requestForDate.time + ":" + "00"
            : "" + " " + this.requestForDate.date != undefined
            ? this.requestForDate.date
            : "";
      }
      if (
        this.requestForDate.direction === "FROM_CAL" &&
        this.requestForDate.id === this.client.id &&
        this.requestForDate.tagName === "dp"
      ) {
        this.recId = this.requestForDate.id;
        this.tagName = this.requestForDate.tagName;
        this.newDate = this.requestForDate.date;
        this.newHours = this.requestForDate.time;
        this.showDepCal = false;
        this.deposit.dep_date = moment(
          `${this.newDate} ${this.newHours}`,
          "YYYY-MM-DD HH:mm:ss"
        ).format("YYYY-MM-DD HH:mm:ss");
        this.totalBrokerTimeAfterChange = this.total;
        // console.log(total._i);
        this.editId = null;

        // const apiUpdatedDate = apiClientCreator(
        //         `client/updatedDateFromPopUp/${clientId}`
        // );
        // apiUpdatedDate
        //         .post("", {
        //           updated_date: newDate,
        //           updated_date_hours : newHours,
        //           tag_name:tagName
        //         })
        //         .then(e => {
        //           this.$emit("updated");
        //         });
      }
    },
    "deposit.call_broker_at": function() {},
    showForm: function() {
      if (!this.CheckUserPermission([1, 2, 3, 4, 12])) {
        this.showDepCal = false;
      }
    },

    scheduledCall: function() {
      this.openSeg = true;
    },
    traToSerchQuery: function(val) {
      ///this.traToSerchQuery=

      if (val.length > 1) {
        this.suggestedUsers = this.filterTransSugUserFunction(
          this.suggestedUsers,
          val
        );
        this.unSuggestedUsers = this.filterTransSugUserFunction(
          this.unSuggestedUsers,
          val
        );
        return (this.uniqueUsers = this.filterUsersFunction(
          this.uniqueUsers,
          val
        ));
      }

      if (val.length === 0 || val === "") {
        return this.getSuggestedUsers(this.client);
      }
    },
    clearClientTags: function() {
      if (this.clearClientTags) {
        if (
          (this.clearClientTags.tag === 1 || this.clearClientTags.tag === 2) &&
          this.clearClientTags.clientId === this.client.id
        ) {
          let tagString;
          this.componentNames = this.componentNames.filter(
            item => item.id !== this.clearClientTags.tag
          );
          switch (this.clearClientTags.tag) {
            case 1:
              tagString = "Bad Number";
              break;
            case 2:
              tagString = "Not Interested";
              break;
            default:
          }

          if (
            this.clearClientTags.tag === 1 &&
            Object.keys(this.BNTimer).length === 0
          ) {
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: `${tagString} Tagging Canceled`,
              type: "DONE",
              op: { type: "SYSTEM" }
            });
          }

          if (
            this.clearClientTags.tag === 2 &&
            Object.keys(this.NITimer).length === 0
          ) {
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: `${tagString} Tagging Canceled`,
              type: "DONE",
              op: { type: "SYSTEM" }
            });
          }
          this.$store.commit("clients/setClearClientTags", null);
        }
      }
    },
    transfer: function() {},
    transferConfirmAnswer: function() {
      /// if(this.transConfReceived === false){
      ///  this.transConfReceived=true

      //this.transRequestSent = false
      this.transRequestReceived = true;
      /// }
    },
    client: function() {
      //this.componentNames =[]
      this.loadTags();
    },
    searchTagQuery: function() {
      this.result = this.filterFunction(this.searchTagQuery);
      if (this.result.length > 0) {
        //todo
        this.showResults = true;
      }
      if (this.searchTagQuery === "") {
        this.showResults = false;
      }
    },
    sendUpdated: function() {
      this.checkPrevBlock();
      /* if(this.sendUpdated===true){
    }*/
      //   this.loadTags();
      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.id === 0
      ) {
        /*        if (this.client.na.length) {
                      this.componentNames = this.componentNames.filter(
                        item => item.id !== 3
                      );
                    }
                    this.componentNames = [
                      {
                        id: 3,
                        name: Na,
                        rm: "UNTAG_NA",
                        data: this.client.na
                      },
                      ...this.componentNames
                    ];*/
        this.componentNames = [];
        this.loadTags();
        // this.selectedTag.type = null;
        // this.selectedTag.id = null;
        this.selectedTag = {};
      }
      if (this.sendUpdated === true && this.untagType === tagTypes.UNTAG_NA) {
        this.componentNames = this.componentNames.filter(item => item.id !== 3);
        if (this.client.na.length) {
          this.componentNames = [
            {
              id: 3,
              name: Na,
              rm: "UNTAG_NA",
              data: this.client.na,
              na_count: this.client.na_count.count
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }
      //////////////////////////////////////////////////////////////////////////////////////////// "BAD_NUMBER_STATE"
      if (
        this.onGroupTagging === true &&
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === "BAD_NUMBER_STATE"
      ) {
        if (this.client.bad_number_state_id !== null) {
          this.componentNames = this.componentNames.filter(
            item => item.id !== 1
          );
        }
        this.componentNames = [
          {
            id: 1,
            name: BN,
            rm: "UNTAG_BN",
            data: this.client,
            arr: ""
          },
          ...this.componentNames
        ];

        this.selectedTag = {};
        this.onGroupTagging = false;
      }

      if (this.sendUpdated === true && this.untagType === tagTypes.UNTAG_BN) {
        this.componentNames = this.componentNames.filter(item => item.id !== 1);
        if (this.client.na.length) {
          this.componentNames = [
            {
              id: 1,
              name: BN,
              rm: "UNTAG_BN",
              data: this.client,
              arr: ""
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }
      /////////////////////////////////////////////////////////////////////////////////////           NI

      if (
        this.onGroupTagging === true &&
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === "NOT_INTERESTED_STATE"
      ) {
        if (this.client.not_interested_state_id !== null) {
          this.componentNames = this.componentNames.filter(
            item => item.id !== 2
          );
        }
        //  alert('fired')
        this.componentNames = [
          {
            id: 2,
            name: NI,
            rm: "UNTAG_NI",
            data: this.client,
            arr: ""
          },
          ...this.componentNames
        ];

        /*                 this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
        this.onGroupTagging = false;
      }
      //alert("num",this.untagType)
      if (
        this.onGroupTagging === true &&
        this.sendUpdated === true &&
        this.untagType === tagTypes.UNTAG_NI
      ) {
        this.componentNames = this.componentNames.filter(item => item.id !== 2);
        if (this.client.na.length) {
          this.componentNames = [
            {
              id: 2,
              name: NI,
              rm: "UNTAG_NI",
              data: this.client
            },
            ...this.componentNames
          ];
        }

        // this.componentNames =[]
        // this.loadTags();

        this.untagType = null;
        this.onGroupTagging = false;
      }
      /////////////////////////////////////////////////////////////////////////////////////////////////////////// LEAD
      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === tagTypes.TAG_LEAD
      ) {
        /*        if (this.client.leads.length) {
                      this.componentNames = this.componentNames.filter(
                        item => item.id !== 4
                      );
                    }
                    this.componentNames = [
                      {
                        id: 4,
                        name: Leads,
                        rm: "UNTAG_LEAD",
                        data: this.client.leads
                      },
                      ...this.componentNames
                    ];*/
        this.componentNames = [];
        this.loadTags();
        /*             this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
      }
      if (this.sendUpdated === true && this.untagType === tagTypes.UNTAG_LEAD) {
        this.componentNames = this.componentNames.filter(item => item.id !== 4);
        if (this.client.leads.length) {
          this.componentNames = [
            {
              id: 4,
              name: Leads,
              rm: "UNTAG_LEAD",
              data: this.client.leads
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }

      ////////////////////////////////////////////////////////////////////////////////////////////// Referrals
      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === tagTypes.TAG_REFERRAL
      ) {
        /*        if (this.client.leads.length) {
                      this.componentNames = this.componentNames.filter(
                        item => item.id !== 5
                      );
                    }
                    this.componentNames = [
                      {
                        id: 5,
                        name: Referral,
                        rm: "UNTAG_REFERRAL",
                        data: this.client.referrals,
                        tagIdNum: this.client.referrals[0].id
                      },
                      ...this.componentNames
                    ];*/
        this.componentNames = [];
        this.loadTags();

        /*                    this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
      }
      if (
        this.sendUpdated === true &&
        this.untagType === tagTypes.UNTAG_REFERRAL
      ) {
        this.componentNames = this.componentNames.filter(item => item.id !== 5);
        if (this.client.leads.length) {
          this.componentNames = [
            {
              id: 5,
              name: Referral,
              rm: "UNTAG_REFERRAL",
              data: this.client.referrals,
              tagIdNum: this.client.referrals[0].id
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }
      ////////////////////////////////////////////////////////////////////////////////////// Transfers

      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === tagTypes.TAG_TRANSFER
      ) {
        if (this.client.transfers.length) {
          this.componentNames = this.componentNames.filter(
            item => item.id !== 6
          );
        }
        this.componentNames = [
          {
            id: 6,
            name: Transfer,
            rm: "UNTAG_TRANSFER",
            data: this.client.transfers,
            tagIdNum: this.client.transfers[0].id
          },
          ...this.componentNames
        ];

        /*                    this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
      }
      if (
        this.sendUpdated === true &&
        this.untagType === tagTypes.UNTAG_TRANSFER
      ) {
        this.componentNames = this.componentNames.filter(item => item.id !== 6);
        if (this.client.transfers.length) {
          this.componentNames = [
            {
              id: 6,
              name: Transfer,
              rm: "UNTAG_TRANSFER",
              data: this.client.transfers,
              tagIdNum: this.client.transfers[0].id
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }

      //////////////////////////////////////////////////////////////////////////////////////// Deposits

      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === tagTypes.TAG_DEPOSIT
      ) {
        /*        if (this.client.deposits.length) {
                      this.componentNames = this.componentNames.filter(
                        item => item.id !== 7
                      );
                    }
                    this.componentNames = [
                      {
                        id: 7,
                        name: Deposits,
                        rm: "UNTAG_DEPOSIT",
                        data: this.client.deposits,
                        tagIdNum: this.client.deposits[0].id,
                        availableStatuses: this.dictionaries.activity.client_deposit_types, //this.deposit.availableStatuses,
                        depositsLog: this.client.deposits_log
                      },
                      ...this.componentNames
                    ];*/
        this.componentNames = [];
        this.loadTags();
        /*                    this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
      }

      if (
        this.sendUpdated === true &&
        this.untagType === tagTypes.UNTAG_DEPOSIT
      ) {
        this.componentNames = this.componentNames.filter(item => item.id !== 7);
        if (this.client.deposits.length) {
          this.componentNames = [
            {
              id: 7,
              name: Deposits,
              rm: "UNTAG_DEPOSIT",
              data: this.client.deposits,
              client_dep: this.client,
              answers: {
                answers: this.client.support_deposits_answers,
                contact_at: this.client.support_deposits_contact_docs
              },
              answers_log: this.client.support_deposits_answers_log,
              country: this.client.country,
              tagIdNum: this.client.deposits[0].id,
              availableStatuses: this.deposit.availableStatuses,
              initiatedFiltering: this.initiatedFiltering,
              queryObject: this.queryObject
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }
      ///////////////////////////////////////////////////////////////////////////////////////////// Scheduled Call
      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === tagTypes.TAG_SCHEDULE_CALL
      ) {
        if (this.client.scheduled_calls.length) {
          this.componentNames = this.componentNames.filter(
            item => item.id !== 8
          );
        }
        this.componentNames = [
          {
            id: 8,
            name: ScheduledCall,
            rm: "UNTAG_SCHEDULED_CALL",
            data: this.client.scheduled_calls,
            client_data: this.client,
            tagIdNum: this.client.scheduled_calls[0].id,
            log: this.client.scheduled_calls_log
          },
          ...this.componentNames
        ];

        /*                    this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
      }

      if (
        this.sendUpdated === true &&
        this.untagType === tagTypes.UNTAG_SCHEDULED_CALL
      ) {
        this.componentNames = this.componentNames.filter(item => item.id !== 8);
        if (this.client.scheduled_calls.length) {
          this.componentNames = [
            {
              id: 8,
              name: ScheduledCall,
              rm: "UNTAG_SCHEDULED_CALL",
              data: this.client.scheduled_calls,
              client_data: this.client,
              tagIdNum: this.client.scheduled_calls[0].id,
              log: this.client.scheduled_calls_log
            },
            ...this.componentNames
          ];
        }
        this.untagType = null;
      }

      /////////////////////////////////////////////////////////////////////////////////////////wait
      if (
        this.sendUpdated === true &&
        this.selectedTag !== null &&
        this.selectedTag.type === tagTypes.TAG_WAITING
      ) {
        /*        if (this.client.deposits.length) {
                              this.componentNames = this.componentNames.filter(
                                item => item.id !== 7
                              );
                            }
                            this.componentNames = [
                              {
                                id: 7,
                                name: Deposits,
                                rm: "UNTAG_DEPOSIT",
                                data: this.client.deposits,
                                tagIdNum: this.client.deposits[0].id,
                                availableStatuses: this.dictionaries.activity.client_deposit_types, //this.deposit.availableStatuses,
                                depositsLog: this.client.deposits_log
                              },
                              ...this.componentNames
                            ];*/
        this.componentNames = [];
        this.loadTags();
        /*                    this.selectedTag.type = null;
                    this.selectedTag.id = null;*/
        this.selectedTag = {};
      }

      if (
        this.sendUpdated === true //&&
        //   this.untagType === tagTypes.UNTAG_DEPOSIT
      ) {
        /*        this.componentNames = this.componentNames.filter(item => item.id !== 7);
                    if (this.client.deposits.length) {
                      this.componentNames = [
                        {
                          id: 7,
                          name: Deposits,
                          rm: "UNTAG_DEPOSIT",
                          data: this.client.deposits,
                          tagIdNum: this.client.deposits[0].id,
                          availableStatuses: this.deposit.availableStatuses
                        },
                        ...this.componentNames
                      ];
                    }*/
        this.untagType = null;
      }
    }
  },
  created() {
    // window.addEventListener("click", this.closeDropdown);
    this.loadTags();
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    getOfficialName(person){
      let officialName=''
      officialName += person.first_name.charAt(0).toUpperCase()+person.first_name.slice(1)+' '
      officialName+=person.last_name.charAt(0).toUpperCase()+'.';
      return officialName;
    },
    filterNiSerch(niSearchQuery,niAll){
      this.niSerchResults = niAll.filter(ni=>{
        niSearchQuery = niSearchQuery.trim();
        niSearchQuery = niSearchQuery.toLowerCase();
        let afterRegex = niSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return ni.name.toLowerCase().includes(afterRegex);
      })
    },
    filterExtraSerch(extraSearchQuery,extraAll){
      this.extraSerchResults = extraAll.filter(extra=>{
        extraSearchQuery = extraSearchQuery.trim();
        extraSearchQuery = extraSearchQuery.toLowerCase();
        let afterRegex = extraSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return extra.name.toLowerCase().includes(afterRegex);
      })
    },
    filterLangSerch(langSearchQuery,langAll){
      this.langSerchResults = langAll.filter(lang =>{
        langSearchQuery = langSearchQuery.trim();
        langSearchQuery = langSearchQuery.toLowerCase();
        let afterRegex = langSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return lang.name.toLowerCase().includes(afterRegex);
      })

    },
    filterbnSerch(bnSearchQuery,bnAll){
      this.bnSerchResults = bnAll.filter(bn=>{
        bnSearchQuery = bnSearchQuery.trim();
        bnSearchQuery = bnSearchQuery.toLowerCase();
        let afterRegex = bnSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return bn.name.toLowerCase().includes(afterRegex);
      })
    },
    filterRfCamp(rfCampSearchQuery,rfCamp){
      this.rfCampSerchResults = rfCamp.filter(rCamp =>{
        rfCampSearchQuery = rfCampSearchQuery.trim();
        rfCampSearchQuery = rfCampSearchQuery.toLowerCase();
        let afterRegex = rfCampSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return rCamp.name.toLowerCase().includes(afterRegex);
      })
    },
    filterldCamp(ldCampSearchQuery,ldCamp){
      this.ldCampSerchResults = ldCamp.filter(lCamp =>{
        ldCampSearchQuery = ldCampSearchQuery.trim();
        ldCampSearchQuery = ldCampSearchQuery.toLowerCase();
        let afterRegex = ldCampSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return lCamp.name.toLowerCase().includes(afterRegex);
      })

    },
    filterDepMethdsSerch(depMethdsSearchQuery,depMethds){
      this.depMethdsSerchResults = depMethds.filter(dMethds =>{
        depMethdsSearchQuery = depMethdsSearchQuery.trim();
        depMethdsSearchQuery = depMethdsSearchQuery.toLowerCase();
        let afterRegex = depMethdsSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return dMethds.method.toLowerCase().includes(afterRegex);

      })
    },
    filterDepStatSerch(depStatSearchQuery,depStat){
      this.depStatSerchResults = depStat.filter(dStat =>{
        depStatSearchQuery = depStatSearchQuery.trim();
        depStatSearchQuery = depStatSearchQuery.toLowerCase();
        let afterRegex = depStatSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return dStat.type.toLowerCase().includes(afterRegex);
      })
    },
    filterDepFor(depForSearchQuery,depFor){
      this.depForSerchResults = depFor.filter(dFor=>{
        depForSearchQuery = depForSearchQuery.trim();
        depForSearchQuery = depForSearchQuery.toLowerCase();
        let afterRegex = depForSearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return dFor.full_name.toLowerCase().includes(afterRegex);
      })
    },
    filterCampsForDep(depCampSearchQuery,campaigns){

      this.campaignSerchResults = campaigns.filter(camp =>{
        depCampSearchQuery = depCampSearchQuery.trim();
        depCampSearchQuery = depCampSearchQuery.toLowerCase();
        let afterRegex = depCampSearchQuery.replace(
            /[.*+\-?^${}()|[\]\\]/g,
            ""
        );
        return camp.name.toLowerCase().includes(afterRegex);
      })
    },
    changeShowForm() {
      setTimeout(() => (this.showForm = false), 1000);
    },
    closeAll() {
      this.suggestedUsers = [];
      this.unSuggestedUsers = [];
      this.uniqueUsers = [];
      this.tra_to_visibility = true;
      // change_the_class_visibility: true,
      this.choosedType = "Selected Transfer Type";
      this.choosedTraTo = "Transfer Client To";
      this.traToSerchQuery = "";
      this.searchRes = null;
      this.choosedFromSearchR = null;
      this.openMoreTagsMenu = false;
      this.showExtra = false;
      this.openSkypeEdit = false;
      this.openSeg = false;
      this.showDepCal = false;
      this.showfirstPartTrForm = true;
      this.hideTheRestAfterTr = false;
      this.hideTheRestAfterCa = false;
      this.sCformSecPart = false;
      this.showScCal = false;
      this.showLdCal = true;
      this.showFromAfterLd = true;
      this.showRfCal = false;
      this.showRestAfterRf = true;
      this.showFormAfterCom = true;
      this.showFormAfterNi = true;
      this.showFormAfterLng = true;
      this.hideAllAfterBN = false;
      this.hideSecDepCalAfterDateChoosed = false;
      this.showScTrCal = true;
      this.datePickerKey = 1;
      this.plusHovered = false;
      this.openCustomSelectF1 = false;
      this.openCustomSelectF2 = false;
      this.openCustomSelectF3 = false;
      this.openCustomSelectF4 = false;
      this.openCustomSelectF5 = false;
      this.openCustomSelectF6 = false;
      this.openCustomSelectF7 = false;
      this.optionClicked = null;
      this.optionClickedF1 = null;
      this.optionClickedF2 = null;
      this.optionClickedF3 = null;
      this.optionClickedF4 = null;
      this.optionClickedF5 = null;
      this.optionClickedF6 = null;
      this.optionClickedF7 = null;
      this.textOrDate = "Choose date From Main Cal ";
      this.depositDate = false;
      this.newDate = null;
      this.newHours = null;
      this.langSerch= "";
      this.bnSerch = "";
      this.extraSerch = "";
      this.niSerch = "";

      if (
        event.target.className !== "date-number" &&
        event.target.className !== "tag_from_tags" &&
        event.target.className !== "tag_from_tag"
      ) {
        this.showForm = false;
        this.showDepositForm = false;
      }
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM");
    },
    sendNewDateFromPopUpToDB() {
      if (!this.depositDate) {
        this.updateDepScheduledCallDate();
      } else {
        this.updateDepDate();
      }
    },
    sendVuexToCal(dep = null) {
      if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
        if (dep) {
          this.editId = dep;
          this.$store.commit("clients/setRequestForDate", {
            tagName: "dp",
            fromWhere: "deposits",
            calendar: "DEP",
            id: dep,
            direction: "FROM_TAG"
          });
        } else {
          this.$store.commit("clients/setRequestForDate", {});
        }
      }
    },
    clearAllFields() {
      this.openCustomSelectF1 = false;
      this.openCustomSelectF2 = false;
      this.openCustomSelectF3 = false;
      this.openCustomSelectF4 = false;
      this.openCustomSelectF5 = false;
      this.openCustomSelectF6 = false;
      this.openCustomSelectF7 = false;
      this.optionClicked = null;
      this.optionClickedF1 = null;
      this.optionClickedF2 = null;
      this.optionClickedF3 = null;
      this.optionClickedF4 = null;
      this.optionClickedF5 = null;
      this.optionClickedF6 = null;
      this.optionClickedF7 = null;
      this.lead.comment = "";
    },
    openCaComponent(clientId,userId = false) {
      this.showForm = false;
      this.$store.commit("clients/setOpenCaComponent", {
        ifOpen: true,
        clientId: clientId,
        date: moment().format("YYYY-MM-DD"),
        fromTable: true,
        clientObj: this.client,
        userId:userId
      });
      this.changeShowForm;
    },
    measureLen() {
      let tempA = document.getElementsByClassName("tag-block");

      // tempA.forEach(e => {
      // });
    },
    createMoment(x) {
      return moment(x).format("HH:mm DD/MM/YY ");
    },
    showOrHide() {
      if (moment(this.referral.payment_on).format("HH:mm") !== "00:00") {
        this.showRfCal = false;
      }

      if (moment(this.lead.payment_on).format("HH:mm") !== "00:00") {
        this.showLdCal = false;
      }

      if (moment(this.scheduledCall).format("HH:mm") !== "00:00") {
        this.sCformSecPart = true;
        this.showScCal = true;
      }
      if (moment(this.deposit.dep_date).format("HH:mm") !== "00:00") {
        this.showDepCal = false;
      }
      if (moment(this.transfer.scheduledCall).format("HH:mm") !== "00:00") {
        this.showScTrCal = false;
      }
      if (
        moment(this.deposit.call_broker_at).format("HH:mm") !==
          "Invalid date" &&
        moment(this.deposit.call_broker_at).format("HH:mm") !== "00:00"
      ) {
        this.hideSecDepCalAfterDateChoosed = true;
      }

      // $(".mx-time-option .active").click(()=>{
      //   this.showDepCal = false;
      // })
      $(".forhoveringNi").hover(
        () => {
          $("#collapse11-" + this.client.id).collapse("show");
          this.showFormAfterNi = false;
        },
        () => {
          $("#collapse11-" + this.client.id).collapse("hide");
          this.showFormAfterNi = true;
        }
      );

      $(".forhoveringLng").hover(
        () => {
          $("#collapse8-" + this.client.id).collapse("show");
          this.showFormAfterLng = false;
        },
        () => {
          $("#collapse8-" + this.client.id).collapse("hide");
          this.showFormAfterLng = true;
        }
      );
      $(".forhoveringCom").hover(
        () => {
          $("#collapse10-" + this.client.id).collapse("show");
          this.showFormAfterCom = false;
        },
        () => {
          $("#collapse10-" + this.client.id).collapse("hide");
          this.showFormAfterCom = true;
        }
      );
    },
    closeIt() {
      if (this.scheduledCallComment != "") {
        $(".#collapse4-" + client.id).collapse();
      }

      if (
        event.target.parentNode &&
        (event.target.parentNode.className != "cell active" ||
          event.target.parentNode.className != "cell today active" ||
          event.target.parentNode.className != "adddepform closeAnswersOpt" ||
          event.target.className != "answer-menu-item")
      ) {
        this.showForm = false;
        this.showExtra = false;
        this.showDepositForm = false;
        // this.showForm = false;
        this.showfirstPartTrForm = true;
        this.hideTheRestAfterTr = false;
        this.showTransferForm = false;
        this.transInit = false;

        this.showReferralForm = false;
        this.showRfCal = true;
        this.showRestAfterRf = true;

        this.showLeadForm = false;
        this.showLdCal = true;
        this.showFromAfterLd = true;

        this.showDepositForm = false;
        this.showDepCal = true;

        this.showScheduleCallForm = false;
        this.hideTheRestAfterCa = false;
        this.sCformSecPart = false;
        this.showScCal = false;

        this.hideAllAfterBN = false;

        this.showFormAfterLng = true;
        this.showFormAfterCom = true;
        this.showFormAfterNi = true;

        this.hideSecDepCalAfterDateChoosed = false;
        this.deposit.call_broker_at = "Invalid date";
        this.scDepDateCheckBox = true;

        this.deposit.dep_date = null;
        this.deposit.call_broker_at = null;
        this.transfer.scheduledCall = null;
        this.scheduledCall = null;
        this.lead.payment_on = null;
        this.referral.payment_on = null;

        this.transRequestSent = false;
        this.transRequestReceived = false;
        this.suggestedUsers = [];
        this.unSuggestedUsers = [];
        this.uniqueUsers = [];

        this.resetAllForms();
        (this.optionClicked = null), (this.optionClickedF1 = null);
        this.optionClickedF2 = null;
        this.optionClickedF3 = null;
        this.optionClickedF4 = null;
        this.optionClickedF5 = null;
        this.optionClickedF6 = null;
        this.optionClickedF7 = null;
      }
    },

    checkHowMatchKids() {},
    //
    // traSearch() {
    //   this.searchRes = this.filterUsersFunction(this.traToSerchQuery);
    //   // if(this.serchRes.length == 0){
    //   //   this.serchRes=this.FilterNonActiveUsers(this.suggestedUsers)
    //   //   if(this.serchRes.length == 0){
    //   //     this.serchRes=this.FilterNonActiveUsers(this.unSuggestedUsers)
    //   //   }
    //   // }
    //   //  this.bulkAssignToQuery=this.FilterNonActiveUsers(this.uniqueUsers)
    //   //  this.bulkAssignToQuery=this.FilterNonActiveUsers(this.unSuggestedUsers)
    // },

    deleteFile(clientId) {
      if (localStorage.getItem("depositAnswers")) {
        let TempObj = JSON.parse(localStorage.getItem("depositAnswers"));
        if (TempObj.length > 0) {
          let idx = TempObj.findIndex(id => id.client_id === clientId);
          if (idx > -1) {
            if (TempObj[idx].hasOwnProperty("file_url")) {
              delete TempObj[idx].file_url;
              localStorage.setItem("depositAnswers", JSON.stringify(TempObj));
              this.$emit("updated");
            }
          }
        }
      }
    },
    checkForContactBy(clientId) {
      if (localStorage.getItem("depositAnswers")) {
        let TempObj = JSON.parse(localStorage.getItem("depositAnswers"));
        if (TempObj.length > 0) {
          let idx = TempObj.findIndex(id => id.client_id === clientId);
          if (idx > -1) {
            if (TempObj[idx].hasOwnProperty("contacted_by")) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      }
    },
    checkFileUrl(clientId) {
      if (localStorage.getItem("depositAnswers")) {
        let TempObj = JSON.parse(localStorage.getItem("depositAnswers"));
        if (TempObj.length > 0) {
          let idx = TempObj.findIndex(id => id.client_id === clientId);
          if (idx > -1) {
            if (TempObj[idx].hasOwnProperty("file_url")) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      }
    },
    returnDepMenuTabs() {
      let tempObj = this.depMenuTabs;
      if (this.deposit.campaign_id) {
        return tempObj;
      } else {
        return tempObj.filter(data => data.id !== 3);
      }
    },
    updateClients() {
      this.$emit("updated");
    },
    scDepDateClicked(e) {
      this.scDepDateCheckBox = e.target.checked;
    },
    sendTransConfirmReq() {
      const req = {
        req_crm_user_id: this.auth.user.id,
        client_id: this.client.id,
        transfer_type: this.transfer.type
      };
      this.transRequestSent = true;
    ///  this.trSocket.emit("request_transfer_confirm", req); //todo: temp disabled 28-02-21
    },
    filterExistingBroker(brokers) {
      let brokerIds = [];
      let newBrokers = brokers;
      this.client.deposits.forEach(deposit => {
        brokerIds.push(deposit.campaign_id);
        newBrokers = newBrokers.filter(
          broker => broker.id !== deposit.campaign_id
        );
      });
      return newBrokers;
      //  brokerIds.forEach(id =>{
      //  newBrokers =newBrokers.filter(broker=>broker.id !== id)
      //  newBrokers = brokers.filter(broker=>broker.id !== id)
      //   })
    },

    checkPrevBlock() {
      // localStorage.setItem('lock-client', id);
      const block = localStorage.getItem("lock-client");
      block === null ? (this.lockTagBtn = false) : (this.lockTagBtn = true);
    },
    /*    checkPrivileges(data) {
      if (this.isAdmin || this.isSalesManager) {
        return data;
      }
      return data.filter(item => item.id !== 5);
    },*/
    checkPrivileges(data) {
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 12])) {
        return data;
      }
      return data.filter(
        item => item.id !== 4 && item.id !== 7 && item.id !== 5
      );
    },
    filterPriority3() {
      return this.dictionaries.activity.client_priorities.filter(
        item => item.id !== 3
      );
    },
    updateDepStat() {
      this.selectedTag.type = tagTypes.TAG_DEPOSIT;
      this.$emit("updated");
    },
    notAssignedErr(clientId) {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "You need to Assign this client to continue work on him !",
        type: "WARNING",
        op: {
          type: "ASSIGN",
          clientId: clientId
        }
      });
    },
    notActiveErr(clientId) {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: `Client #${clientId} deactivated, do you want to activate?`,
        type: "WARNING",
        op: {
          type: "NAC",
          clientId: clientId
        }
      });
    },
    showOriginClient(val) {
      this.$emit("origin", val);
    },
    showMergedClient(val) {
      this.$emit("merged", val);
    },
    async saveAssignment(assignTo, type) {
      this.$store.commit("clients/setLoading", true);
      if (type === "UNTAG") {
        await assignmentUnTag(this.client);
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client returned to general pupulation",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        return this.$emit("updated");
      }
      return this.$emit("updated");

      /*      await groupAssignmentTag(this.client, assignTo);
      this.$store.commit("clients/setLoading", false);
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Client Assignment To Group Completed",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$emit("updated");*/
    },

    cancelAssignTimers(tag, clientId) {
      this.componentNames = this.componentNames.filter(item => item.id !== tag);
      //
      // for (let i = 0; i < this.timeouts.length; i++) {
      //
      // }
      // this.timeouts = [];
      let tagString;
      if (tag === 1) {
        if (this.BNTimer.hasOwnProperty(clientId)) {
          clearTimeout(this.BNTimer[clientId]);
          let tempObj = Object.assign({}, this.BNTimer);
          delete tempObj[clientId];
          this.$store.commit("clients/setBNTimer", tempObj);
          tagString = "Bad Number";
        }
      }
      if (tag === 2) {
        if (this.NITimer.hasOwnProperty(clientId)) {
          clearTimeout(this.NITimer[clientId]);
          let tempObj = Object.assign({}, this.NITimer);
          delete tempObj[clientId];
          this.$store.commit("clients/setNITimer", tempObj);
          tagString = "Not Interested";
        }
      }
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: `${tagString} Tagging Canceled`,
        type: "DONE",
        op: { type: "SYSTEM" }
      });
    },

    applySearchTag(item) {
      if (item.tag === tagTypes.TAG_TRANSFER) {
        this.resetResults();
        return (this.showTransferForm = true);
      }
      if (item.tag === tagTypes.TAG_NA) {
        this.resetResults();
        return this.applyTag({ id: 0, type: "TAG_NA" });
      }
      if (item.tag === tagTypes.TAG_NA_VM) {
        this.resetResults();
        return this.applyTag({ id: 0, type: "TAG_NA_VM" });
      }
      if (item.tag === tagTypes.TAG_SCHEDULE_CALL) {
        this.resetResults();
        return this.applyTag({ type: "TAG_SCHEDULE_CALL" });
      }
      if (
        item.name === "skype" ||
        item.name === "phone" ||
        item.name === "email_sent" ||
        item.name === "email_received" ||
        item.name === "sms"
      ) {
        this.resetResults();
        return this.saveCommunication(item);
      }
      if (item.tag === tagTypes.TAG_ENDED) {
        this.resetResults();
        return this.applyTagEnded();
      }

      if (item.tag === tagTypes.TAG_WAITING) {
        this.resetResults();
        return this.applyTagWaiting();
      }

      if (item.tag === tagTypes.TAG_TIER4) {
        this.resetResults();
        return this.applyTagTier4();
      }

      if (item.type === tagTypes.BAD_NUMBER_STATE) {
        this.resetResults();
        return this.applyTag(item);
      }
      if (item.type === tagTypes.BAD_NUMBER_STATE) {
        this.resetResults();
        return this.applyTag(item);
      }
      if (item.type === tagTypes.NOT_INTERESTED_STATE) {
        this.resetResults();
        return this.applyTag(item);
      }
      if (item.tag === tagTypes.TAG_LEAD) {
        this.resetResults();
        return this.applyTag({ type: "TAG_LEAD" });
      }
      if (item.tag === tagTypes.TAG_REFERRAL) {
        this.resetResults();
        return this.applyTag({ type: "TAG_REFERRAL" });
      }
      if (item.tag === tagTypes.TAG_DEPOSIT) {
        this.resetResults();
        return this.applyTag({ type: "TAG_DEPOSIT" });
      }
      if (item.tag === tagTypes.TAG_LANGUAGE) {
        this.resetResults();
        return (this.showLangOptions = true);
      }
    },

    resetResults() {
      this.searchTagQuery = "";
      this.result = [];
      this.showResults = false;
    },
    loadTags() {
      this.checkPrevBlock();
      this.componentNames = [];
      if (
        (this.client.bad_number_state_id !== null &&
          this.selectedTagToFilter !== "BN") ||
        Object.keys(this.BNTimer).includes(this.client.id.toString())
      ) {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 1,
            name: BN,
            rm: "UNTAG_BN",
            data: this.client,
            arr: ""
          }
        ];
      }
      if (
        (this.client.not_interested_state_id !== null &&
          this.selectedTagToFilter !== "NI") ||
        Object.keys(this.NITimer).includes(this.client.id.toString())
      ) {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 2,
            name: NI,
            rm: "UNTAG_NI",
            data: this.client,
            arr: ""
          }
        ];
      }
      if (this.client.na.length && this.selectedTagToFilter !== "NA") {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 3,
            name: Na,
            rm: "UNTAG_NA",
            data: this.client.na,
            tagDate: this.client.na[0].created_at,
            na_count: this.client.na_count.count
            //  arr:this.client.na[this.client.na.length - 1].id
          }
        ];
      }
      if (this.client.leads.length && this.selectedTagToFilter !== "LD") {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 4,
            name: Leads,
            rm: "UNTAG_LEAD",
            data: this.client.leads,
            tagIdNum: this.client.leads[0].id,
            tagDate: this.client.leads[0].created_at
          }
        ];
      }
      if (this.client.referrals.length && this.selectedTagToFilter !== "RF") {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 5,
            name: Referral,
            rm: "UNTAG_REFERRAL",
            data: this.client.referrals,
            tagIdNum: this.client.referrals[0].id,
            tagDate: this.client.referrals[0].created_at
          }
        ];
      }

      if (this.client.transfers.length && this.selectedTagToFilter !== "TR") {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 6,
            name: Transfer,
            rm: "UNTAG_TRANSFER",
            data: this.client.transfers,
            tagIdNum: this.client.transfers[0].id,
            tagDate: this.client.transfers[0].created_at
          }
        ];
      }

      if (this.client.deposits.length && this.selectedTagToFilter !== "DP") {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 7,
            name: Deposits,
            rm: "UNTAG_DEPOSIT",
            data: this.client.deposits,
            client_dep: this.client,
            answers: {
              answers: this.client.support_deposits_answers,
              contact_at: this.client.support_deposits_contact_docs
            },
            answers_log: this.client.support_deposits_answers_log,
            country: this.client.country,
            tagIdNum: this.client.deposits[0].id,
            availableStatuses: this.dictionaries.activity.client_deposit_types, //this.deposit.availableStatuses,
            log: this.client.deposits_log,
            tagDate: this.client.deposits[0].created_at,
            initiatedFiltering: this.initiatedFiltering,
            queryObject: this.queryObject
          }
        ];
      }

      if (
        this.client.scheduled_calls.length &&
        this.selectedTagToFilter !== "CA"
      ) {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 8,
            name: ScheduledCall,
            rm: "UNTAG_SCHEDULED_CALL",
            data: this.client.scheduled_calls,
            client_data: this.client,
            tagIdNum: this.client.scheduled_calls[0].id,
            log: this.client.scheduled_calls_log,
            tagDate: this.client.scheduled_calls[0].created_at
          }
        ];
      }

      if (this.selectedTagToFilter !== "NEW") {
        this.componentNames = [
          ...this.componentNames,
          {
            id: 0,
            name: IsNewOrActive,
            data: this.client,
            arr: ""
          }
        ];
      }
      this.componentNames = this.componentNames.sort(function(a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.tagDate) - new Date(a.tagDate);
      });
      if (this.selectedTagToFilter === "NA") {
        this.componentNames = this.componentNames.filter(item => item.id !== 3);
        this.componentNames = [
          {
            id: 3,
            name: Na,
            rm: "UNTAG_NA",
            data: this.client.na,
            tagDate: this.client.na[0].created_at,
            na_count: this.client.na_count.count
            //  arr:this.client.na[this.client.na.length - 1].id
          },
          ...this.componentNames
        ];
      }
      if (this.selectedTagToFilter === "CA") {
        this.componentNames = this.componentNames.filter(item => item.id !== 8);
        this.componentNames = [
          {
            id: 8,
            name: ScheduledCall,
            rm: "UNTAG_SCHEDULED_CALL",
            data: this.client.scheduled_calls,
            client_data: this.client,
            tagIdNum: this.client.scheduled_calls[0].id,
            log: this.client.scheduled_calls_log,
            tagDate: this.client.scheduled_calls[0].created_at
          },
          ...this.componentNames
        ];
      }
      if (this.selectedTagToFilter === "TR") {
        this.componentNames = this.componentNames.filter(item => item.id !== 6);
        this.componentNames = [
          {
            id: 6,
            name: Transfer,
            rm: "UNTAG_TRANSFER",
            data: this.client.transfers,
            tagIdNum: this.client.transfers[0].id,
            tagDate: this.client.transfers[0].created_at
          },
          ...this.componentNames
        ];
      }
      if (this.selectedTagToFilter === "RF") {
        this.componentNames = this.componentNames.filter(item => item.id !== 5);
        this.componentNames = [
          {
            id: 5,
            name: Referral,
            rm: "UNTAG_REFERRAL",
            data: this.client.referrals,
            tagIdNum: this.client.referrals[0].id,
            tagDate: this.client.referrals[0].created_at
          },
          ...this.componentNames
        ];
      }
      if (this.selectedTagToFilter === "LD") {
        this.componentNames = this.componentNames.filter(item => item.id !== 4);
        this.componentNames = [
          {
            id: 4,
            name: Leads,
            rm: "UNTAG_LEAD",
            data: this.client.leads,
            tagIdNum: this.client.leads[0].id,
            tagDate: this.client.leads[0].created_at
          },
          ...this.componentNames
        ];
      }
      if (this.selectedTagToFilter === "DP") {
        this.componentNames = this.componentNames.filter(item => item.id !== 7);
        this.componentNames = [
          {
            id: 7,
            name: Deposits,
            rm: "UNTAG_DEPOSIT",
            data: this.client.deposits,
            client_dep: this.client,
            answers: {
              answers: this.client.support_deposits_answers,
              contact_at: this.client.support_deposits_contact_docs
            },
            answers_log: this.client.support_deposits_answers_log,
            country: this.client.country,
            tagIdNum: this.client.deposits[0].id,
            availableStatuses: this.dictionaries.activity.client_deposit_types, //this.deposit.availableStatuses,
            log: this.client.deposits_log,
            tagDate: this.client.deposits[0].created_at,
            initiatedFiltering: this.initiatedFiltering,
            queryObject: this.queryObject
          },
          ...this.componentNames
        ];
      }
      if (this.selectedTagToFilter === "NEW") {
        this.componentNames = this.componentNames.filter(item => item.id !== 0);
        this.componentNames = [
          {
            id: 0,
            name: IsNewOrActive,
            data: this.client,
            arr: ""
          },
          ...this.componentNames
        ];
      }
    },
    filterFunction(userInput) {
      let tempObj = [
        ...this.dictionaries.activity.client_deposit_types,
        ...tagSearchList,
        ...this.dictionaries.activity.bad_number_states,
        ...this.dictionaries.activity.scheduled_calls_statuses
      ];
      return tempObj.filter(function(broker) {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        if (broker.name) {
          return broker.name.toLowerCase().includes(afterRegex);
        } else if (broker.type) {
          return broker.type.toLowerCase().includes(afterRegex);
        }
      });
    },
    filterUsersFunction(arr, userInput) {
      // let temp = [
      //   ...this.uniqueUsers,
      //   ...this.suggestedUsers,
      //   ...this.unSuggestedUsers
      // ];
      return arr.filter(user => {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return user.full_name.toLowerCase().includes(afterRegex);
      });
    },

    filterTransSugUserFunction(arr, searchTerm) {
      let temp = [
        ...this.uniqueUsers,
        ...this.suggestedUsers,
        ...this.unSuggestedUsers
      ];
      return arr.filter(usr => {
        searchTerm = searchTerm.trim();
        searchTerm = searchTerm.toLowerCase();
        let afterRegex = searchTerm.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return usr.data.full_name.toLowerCase().includes(afterRegex);
      });
    },
    // filterList(q) {
    //   function escapeRegExp(s) {
    //     return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    //   }
    //
    //   const words = q
    //     .split(/\s+/g)
    //     .map(s => s.trim())
    //     .filter(s => !!s);
    //   const hasTrailingSpace = q.endsWith(" ");
    //   const searchRegex = new RegExp(
    //     words
    //       .map((word, i) => {
    //         if (i + 1 === words.length && !hasTrailingSpace) {
    //           // The last word - ok with the word being "startswith"-like
    //           return `(?=.*\\b${escapeRegExp(word)})`;
    //         } else {
    //           // Not the last word - expect the whole word exactly
    //           return `(?=.*\\b${escapeRegExp(word)}\\b)`;
    //         }
    //       })
    //       .join("") + ".+",
    //     "gi"
    //   );
    //   return tagSearchList.filter(item => {
    //     return searchRegex.test(item.name);
    //   });
    // },

    resetAllForms() {
      this.lead.comment = "";
      this.lead.payment_on = null;
      this.lead.campaign_id = null;
      this.referral.comment = "";
      this.referral.payment_on = null;
      this.referral.campaign_id = null;
      this.transfer.type = null;
      // this.transfer.to = null;
      (this.transfer.to = { user: { full_name: " " }, idx: null }),
        (this.transfer.scheduledCall = null);
      this.communication.type = null;
      this.communication.contacted_in = null;
      this.scheduledCall = null;
      this.scheduledCallComment =
        this.scheduledCallComment != "" ? this.scheduledCallComment : "";
      this.scheduledCallCommentError = "";
      this.scheduledCallStatus = null;
      this.scheduledCallStatusText = "Select reason/status";
      this.scheduledCallPriority = null;
      this.scheduledCallPriorityTitle = "Select Priority";
      this.traToSerchQuery = "";
      this.choosedTraTo = "Transfer Client To";
      // this.change_the_class_visibility = true;
      // this.showSearchInp = false;
      this.suggestedUsers = [];
      this.unSuggestedUsers = [];
      this.uniqueUsers = [];
      this.tra_to_visibility = true;
      this.showForm = false;
      this.editSkype = false;
      this.showCommForm = false;
      this.openSkypeEdit = false;
      this.communication.contacted_in = "";
      // class="sec_drop_tra_to"
      //   v-if="tra_to_visibility && !change_the_class_visibility"
    },
    closeDropdown() {
      this.showForm = false;
      // this.showLangOptions =false;
    },

    removeCommTag(tagIdNum) {
      this.removeTag("UNTAG_COMM", this.client.id, tagIdNum);
    },

    async saveTransfer(clientId) {
      this.selectedTag.type = tagTypes.TAG_TRANSFER;
      if (this.transfer.type !== null && !this.transInit) {
        let group_assign_str = "";
        if (this.selectedMainTab === "total") {
          if (
            this.client.assignment_group &&
            this.client.assignment_group.assigned_to.id === 2
          ) {
            group_assign_str = "na";
          }
          if (
            this.client.assignment_group &&
            this.client.assignment_group.assigned_to.id === 3
          ) {
            group_assign_str = "ni";
          }
          if (
            this.client.assignment_group &&
            this.client.assignment_group.assigned_to.id === 4
          ) {
            group_assign_str = "bn";
          }
        }
        this.transInit = true;
        this.$store.commit("clients/setLoading", true);
        if (isNaN(Date.parse(this.transfer.scheduledCall))) {
          await this.tagTransfer(clientId, {
            trans_type_id: this.transfer.type,
            trans_to_id: this.transfer.to.user.id,
            trans_to_idx: this.transfer.to.idx, //TODO: suggestion score place index
            trans_from_id: this.client.assignment.assigned_id,
            trans_from_group:
              this.selectedMainTab === "total"
                ? group_assign_str
                : this.selectedMainTab
          });
          this.transInit = false;
        } else {
          this.transInit = true;
          await this.tagTransfer(clientId, {
            trans_type_id: this.transfer.type,
            trans_to_id: this.transfer.to.user.id,
            // trans_to_id: this.transfer.to.user.id?this.transfer.to.user.id:this.choosedFromSearchR.id,
            trans_to_idx: this.transfer.to.idx, //TODO: suggestion score place index
            trans_from_id: this.client.assignment.assigned_id,
            scheduled_call: this.transfer.scheduledCall,
            trans_from_group:
              this.selectedMainTab === "total"
                ? group_assign_str
                : this.selectedMainTab
          });
          this.transInit = false;
        }

        this.$emit("updated");
        this.showTransferForm = false;
        this.showForm = false;
        this.resetAllForms();
        this.transRequestSent = false;
        this.transRequestReceived = false;
        this.$store.commit("clients/setLoading", false);
      } else {
        alert("Transfer Type is empty !");
      }
    },

    async applyLangTag(clientId, langId) {
      this.$store.commit("clients/setLoading", true);
      await this.tagLanguage(langId, clientId);
      this.showLangOptions = false;
      this.$emit("updated");
      this.$store.commit("clients/setLoading", false);
    },

    async applyTagWaiting() {
      this.$store.commit("clients/setLoading", true);
      this.selectedTag.type = tagTypes.TAG_WAITING;
      await this.tagWaiting(this.client.id);
      this.showLangOptions = false;

      await this.$emit("updated");

      this.$store.commit("clients/setLoading", false);
    },
    async applyTagEnded() {
      this.$store.commit("clients/setLoading", true);
      await this.tagEnded(this.client.id);
      this.showLangOptions = false;
      this.$emit("updated");
      this.$store.commit("clients/setLoading", false);
    },
    async applyTagTier4() {
      this.$store.commit("clients/setLoading", true);
      await tagTier4(this.client.id);
      this.showLangOptions = false;
      this.$emit("updated");
      this.$store.commit("clients/setLoading", false);
    },

    async removeTag(type, clientId, tagIdNum) {
      const vm = this;
      //  alert(type)
      if (confirm("Are You Sure ?")) {
        this.$store.commit("clients/setLoading", true);

        if (type === tagTypes.UNTAG_BN) {
          //  await untagBN(this.client.bn.id, clientId);

          await this.untagBN(this.client.bn.id, this.client.id);
          this.saveAssignment(null, "UNTAG");
          this.onGroupTagging = true;
          this.untagType = tagTypes.UNTAG_BN;
          vm.$emit("updated");
        }

        if (type === tagTypes.UNTAG_NI) {
          await this.untagNI(this.client.ni.id, this.client.id);
          this.saveAssignment(null, "UNTAG");
          this.onGroupTagging = true;
          this.untagType = tagTypes.UNTAG_NI;
          vm.$emit("updated");
        }

        if (type === tagTypes.UNTAG_NA) {
          await this.untagNA(this.client.na[0].id, clientId);
          this.saveAssignment(null, "UNTAG");
          this.onGroupTagging = true;

          this.untagType = tagTypes.UNTAG_NA;
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_SCHEDULED_CALL) {
          await this.untagScheduledCall(tagIdNum, clientId);
          this.untagType = tagTypes.UNTAG_SCHEDULED_CALL;
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_LEAD) {
          await this.untagLead(tagIdNum, clientId);
          this.untagType = tagTypes.UNTAG_LEAD;
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_REFERRAL) {
          await this.untagReferral(tagIdNum, clientId);
          this.untagType = tagTypes.UNTAG_REFERRAL;
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_DEPOSIT) {
          await this.untagDeposit(tagIdNum, clientId);
          this.untagType = tagTypes.UNTAG_DEPOSIT;
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_COMM) {
          await this.untagCommunication(tagIdNum, clientId);
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_LANGUAGE) {
          await this.untagLanguage(clientId);
          vm.$emit("updated");
        }

        if (type === tagTypes.UNTAG_WAITING) {
          await this.untagWaiting(this.client.client_waiting.id, clientId);
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_ENDED) {
          await this.untagEnded(this.client.client_ended.id, clientId);
          vm.$emit("updated");
        }
        if (type === tagTypes.UNTAG_TIER4) {
          await this.untagEnded(this.client.client_ended.id, clientId);
          vm.$emit("updated");
        }

        if (type === tagTypes.UNTAG_TRANSFER) {
          await this.untagTransfer(tagIdNum, clientId);
          this.untagType = tagTypes.UNTAG_TRANSFER;
          vm.$emit("updated");
        }

        vm.editTags = false;
        this.$store.commit("clients/setLoading", false);
      }
    },

    async removeTagFromAct(data) {
      const vm = this;
      //  alert(type)
      if (confirm("Are You Sure ?")) {
        this.$store.commit("clients/setLoading", true);

        if (data.type === "UNTAG_BN") {
          //  await untagBN(this.client.bn.id, clientId);

          await this.untagBN(data.tagIdNum, data.clientId);
          this.saveAssignment(null, "UNTAG");
          this.onGroupTagging = true;
          this.untagType = "UNTAG_BN";
          vm.$emit("updated");
        }

        if (data.type === "UNTAG_NI") {
          await this.untagNI(data.tagIdNum, data.clientId);
          this.saveAssignment(null, "UNTAG");
          this.onGroupTagging = true;
          this.untagType = "UNTAG_NI";
          vm.$emit("updated");
        }
        if (data.type === "UNTAG_NR") {
          await this.untagNA(data.tagIdNum, data.clientId);
          this.saveAssignment(null, "UNTAG");
          this.onGroupTagging = true;
          this.untagType = "UNTAG_NI";
          vm.$emit("updated");
        }

        vm.editTags = false;
        this.$store.commit("clients/setLoading", false);
      }
    },

    applyTag(type) {
      this.selectedTag = type;
      this.addTag();
    },

    async addTag() {
      if (this.selectedTag === null) {
        return false;
      }

      if (this.selectedTag.type === tagTypes.TAG_LEAD) {
        this.showLeadForm = true;
        return;
      }
      if (this.selectedTag.type === tagTypes.TAG_REFERRAL) {
        this.showReferralForm = true;
        return;
      }

      if (this.selectedTag.type === tagTypes.TAG_DEPOSIT) {
        this.showDepositForm = true;
        return;
      }

      if (this.selectedTag.type === tagTypes.TAG_SCHEDULE_CALL) {
        this.showScheduleCallForm = true;
        return;
      }

      let vm = this;
      /// alert(vm.selectedTag.type)
      this.$store.commit("clients/setLoading", true);
      if (vm.selectedTag.type === "BAD_NUMBER_STATE") {
        //   alert(this.selectedTag.type)
        if (this.tabAlias === "bn") {
          await this.tagBN(this.selectedTag, this.client.id);
          this.onGroupTagging = true;
          return vm.$emit("updated");
        }
        if (this.tabAlias === "ni") {
          await this.tagBN(this.selectedTag, this.client.id);
          await this.untagNI(this.client.ni.id, this.client.id);
          this.saveAssignment(4);
          return (this.onGroupTagging = true);
        }
        this.componentNames = this.componentNames.filter(item => item.id !== 1);

        this.componentNames = [
          {
            id: 1,
            name: BN,
            rm: "UNTAG_BN",
            data: this.client,
            arr: ""
          },
          ...this.componentNames
        ];
        let keyBN = this.client.id;
        //  let ti = {
        //     ...this.BNTimer,
        //    [keyBN]: setTimeout(async () => {
        //  let tempObj = Object.assign({}, this.BNTimer); // TODO: REMOVED TO TEST STUCK ISSUE 15-01-21
        //  delete tempObj[keyBN];
        //    this.$store.commit("clients/setBNTimer", tempObj);
        await this.tagBN(this.selectedTag, this.client.id);
        await this.saveAssignment(4);
        this.selectedTag = {};
        //    }, 1000)
        //   };
        //    this.$store.commit("clients/setBNTimer", ti);
        //    let msg;
        //    let cond = false;    // TODO: REMOVED TO TEST STUCK ISSUE 15-01-21
        //    if (Object.keys(this.BNTimer).length <= 1) {
        //      msg = `\nBN #${this.client.id}\n ${this.client.full_name}\n`;
        //    } else {
        //      cond = true;
        //      msg = "\nBN";
        //    }

        // this.$store.commit("main/setShowVikiMsg", {
        //   show: true,
        //   msg: msg,   // TODO: REMOVED TO TEST STUCK ISSUE 15-01-21
        //   type: "TAG",
        //   op: {
        //     type: "SYSTEM",
        //     clientId: this.client.id,
        //     tag_id: 1,
        //     cond: cond
        //   }
        // });
      }

      if (vm.selectedTag.type === "NOT_INTERESTED_STATE") {
        if (this.tabAlias === "ni") {
          await this.tagNI(this.selectedTag, this.client.id);
          this.onGroupTagging = true;
          return vm.$emit("updated");
        }

        if (this.tabAlias === "bn") {
          //await tagBN(this.selectedTag, this.client.id);
          await this.untagBN(this.client.bn.id, this.client.id);
          await this.tagNI(this.selectedTag, this.client.id);
          this.saveAssignment(3);
          return (this.onGroupTagging = true);
          //vm.$emit("updated");
        }

        this.componentNames = this.componentNames.filter(item => item.id !== 2);
        // await tagBN(this.selectedTag, this.client.id);
        /*   if (this.client.bad_number_state_id !== null) {
                      this.componentNames = this.componentNames.filter(
                              item => item.id !== 1
                      );
                    }*/
        this.componentNames = [
          {
            id: 2,
            name: NI,
            rm: "UNTAG_NI",
            data: this.client,
            arr: ""
          },
          ...this.componentNames
        ];
        //  let keyNI = this.client.id;
        //  let ti = {
        //  ...this.NITimer, // TODO: REMOVED TO TEST STUCK ISSUE 15-01-21
        //  [keyNI]: setTimeout(async () => {
        //  let tempObj = Object.assign({}, this.NITimer);
        //  delete tempObj[keyNI];
        //  this.$store.commit("clients/setNITimer", tempObj);
        await this.tagNI(this.selectedTag, this.client.id);
        await this.saveAssignment(3);
        this.selectedTag = {};
        //   }, 1000)
        //    };

        // this.$store.commit("clients/setNITimer", ti);
        //
        // let msg;
        // let cond = false;
        // if (Object.keys(this.NITimer).length <= 1) {  // TODO: REMOVED TO TEST STUCK ISSUE 15-01-21
        //   msg = `\nNI #${this.client.id}\n ${this.client.full_name}\n`;
        // } else {
        //   cond = true;
        //   msg = "\n";
        // }

        // this.$store.commit("main/setShowVikiMsg", {
        //   show: true,
        //   id: null,
        //   msg: msg, // TODO: REMOVED TO TEST STUCK ISSUE 15-01-21
        //   type: "TAG",
        //   op: {
        //     type: "SYSTEM",
        //     clientId: this.client.id,
        //     tag_id: 2,
        //     cond: cond
        //   }
        // });
      }
      if (this.selectedTag.type === tagTypes.TAG_NA) {
        await this.tagNA(this.selectedTag, this.client.id);
        this.$emit("updated");
        this.sendSMSPresetRequest(
          this.client,
          this.dictionaries.activity.sms_presets[1],
          "NA"
        );
      }
      if (this.selectedTag.type === tagTypes.TAG_NA_VM) {
        await this.tagNA(this.selectedTag, this.client.id, true);
        this.$emit("updated");
        this.sendSMSPresetRequest(
          this.client,
          this.dictionaries.activity.sms_presets[1],
          "NA"
        );
      }
      this.showForm = false;
      this.$store.commit("clients/setLoading", false);
    },

    saveCommunication(item) {
      const vm = this;
      if (item.id === 1) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 2) {
        this.showForm = false;
        this.communication.contacted_in = this.client.emails[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 3) {
        this.showForm = false;
        this.communication.contacted_in = this.client.emails[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 4) {
        this.openSkypeEdit = true;
        if (this.client.skype.length === 0) {
          this.communication.type = item;
          return (this.showCommForm = true);
        }
        this.communication.contacted_in = this.client.skype[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 5) {
        this.showForm = false;
        this.communication.contacted_in = "chat";
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 6) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 7) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 8) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 9) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 10) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
      if (item.id === 11) {
        this.showForm = false;
        this.communication.contacted_in = this.client.phones[0].contact_value;
        this.communication.type = item;
        return vm.addCommunication();
      }
    },

    openEditSkype() {
      this.communication.contacted_in = this.client.skype[0].contact_value;
      this.editSkype = true;
    },
    async addNewSkype() {
      this.showForm = false;
      this.openSkypeEdit = false;
      this.communication.contacted_in = "";
      if (this.editSkype) {
        return this.saveUpdatedSkype();
      }
      this.$store.commit("clients/setLoading", true);
      await addSkype(this.client.id, this.communication.contacted_in);
      await this.addCommunication();
    },

    async saveUpdatedSkype() {
      this.$store.commit("clients/setLoading", true);
      await updateSkype(
        this.client.id,
        this.communication.contacted_in,
        this.client.skype[0].id
      );
      this.editSkype = false;
      this.$emit("updated");
      this.showCommForm = false;
      this.selectedTag = null;
      this.resetAllForms();
      this.$store.commit("clients/setLoading", false);
    },

    async addCommunication() {
      this.$store.commit("clients/setLoading", true);
      await this.tagAddCommunication(
        this.communication.contacted_in,
        this.communication.type.id,
        this.client.id
      );
      this.$emit("updated");
      this.showCommForm = false;
      this.selectedTag = null;
      this.resetAllForms();
      this.$store.commit("clients/setLoading", false);
    },

    async saveScheduledCall(clientId) {
      this.selectedTag.type = tagTypes.TAG_SCHEDULE_CALL;
      if (this.scheduledCall === null) {
        return alert("Please Select Date and Time");
      }
      if (this.scheduledCallStatus === null) {
        return alert("Please Select Reason/Status");
      }
      this.showScCal = false;
      this.sCformSecPart = false;
      const newSchduledCall = {
        call_scheduled_on: this.scheduledCall,
        comment: this.scheduledCallComment,
        status_id: this.scheduledCallStatus.id,
        priority_id:
          this.scheduledCallPriority === null
            ? 3
            : this.scheduledCallPriority.id
      };
      try {
        this.$store.commit("clients/setLoading", true);
        const apiClient = apiClientCreator(
          `client/schedule-call/${clientId}`,
          "token"
        );
        await apiClient.post("", newSchduledCall);

        this.showScheduleCallForm = false;
        this.showForm = false;
        this.resetAllForms();
        this.$emit("updated");

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Scheduled Call\n Completed",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.scheduledCall = null;
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Error!  Status:" + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveLeadTag(clientId) {
      if (this.lead.campaign_id === null) {
        return (this.lead.errors = {
          campaign_id: null
        });
      }
      try {
        this.$store.commit("clients/setLoading", true);
        this.selectedTag.type = tagTypes.TAG_LEAD;
        await this.tagLead(this.lead, clientId);

        this.$emit("added");
        this.$emit("updated");
        this.showFromAfterLd = true;
        this.showLdCal = true;
        this.showLeadForm = false;
        this.showForm = false;
        this.lead.comment = "";
        this.lead.payment_on = null;
        this.lead.campaign_id = null;
        this.openCustomSelectF6 = false;
        this.optionClickedF6 = null;
        this.lead.comment = "";
        this.$set(this.lead, "errors", {});

        this.$store.commit("clients/setLoading", false);
      } catch (e) {}
    },

    async saveReferralTag(clientId) {
      if (this.referral.campaign_id === null) {
        return (this.referral.errors = {
          campaign_id: null
        });
      }
      this.$store.commit("clients/setLoading", true);
      this.selectedTag.type = tagTypes;
      await this.tagReferral(clientId, this.referral);
      this.$emit("updated");
      this.showRestAfterRf = true;
      // this.showRfCal = true;
      this.showReferralForm = false;
      this.showForm = false;
      this.referral.comment = "";
      this.optionClickedF7 = null;
      this.optionClickedF7 = null;
      this.referral.payment_on = null;
      this.referral.campaign_id = null;
      this.$store.commit("clients/setLoading", false);
    },
    getWordFromNumber(n) {
      switch (n) {
        case 1:
          return "first";
        case 2:
          return "second";
        case 3:
          return "third";
        case 4:
          return "fourth";
        case 5:
          return "fifth";
        case 6:
          return "sixth";
        case 7:
          return "seventh";
        case 8:
          return "eight";
        case 9:
          return "ninth";
        default:
          return "first";
      }
    },
    async saveDepositTag(client) {
      /*      let vm = this;
                let apiClient = apiClientCreator("client/deposit/" + clientId);*/
      this.selectedTag.type = tagTypes.TAG_DEPOSIT;
      // if (this.deposit.user_id === null) {
      //   return (this.deposit.errors = {
      //     user_id: null
      //   });
      // }
      if (this.deposit.campaign_id === null) {
        return (this.deposit.errors = {
          campaign_id: null
        });
      }

      if (this.deposit.status_id === null) {
        return (this.deposit.errors = {
          status_id: null
        });
      }
      if (this.deposit.method_id === null) {
        return (this.deposit.errors = {
          method_id: null
        });
      }
      if (this.deposit.call_broker_at === null && !this.scDepDateCheckBox) {
        return (this.deposit.errors = {
          call_broker_at: null
        });
      }

      if (client.questions_status < 2) {
        this.selectedDepMenuTab = "QS";
        return (this.deposit.errors = {
          questions: null
        });
      }

      if (this.loading) {
        return false;
      }

      const depositData = {
        campaign_id: this.deposit.campaign_id,
        amount: this.deposit.amount,
        currency_id: this.deposit.currency_id,
        method_id: this.deposit.method_id,
        status_id: this.deposit.status_id,
        comment: this.deposit.comment
      };

      if (this.deposit.user_id !== null || this.deposit.dep_date !== null) {
        const add = {
          user_id: this.deposit.user_id,
          updated_at: this.deposit.dep_date
        };

        Object.assign(depositData, add);
      }

      if (this.deposit.call_broker_at !== null) {
        const add = {
          call_broker_at: this.deposit.call_broker_at
        };

        Object.assign(depositData, add);
      }
      if (this.scDepDateCheckBox) {
        const add = {
          call_broker_at: null
        };

        Object.assign(depositData, add);
      }

      this.$store.commit("clients/setLoading", true);

      if (localStorage.getItem("depositAnswers")) {
        let depSupData = JSON.parse(localStorage.getItem("depositAnswers"));
        let idx = depSupData.findIndex(id => id.client_id === client.id);
        if (idx > -1) {
          let clientSupportData = depSupData[idx].questions;
          depositData.client_support_questions = clientSupportData;
          if (depSupData[idx].hasOwnProperty("contacted_by")) {
            depositData.contact_by = depSupData[idx].contacted_by;
          }
          if (depSupData[idx].hasOwnProperty("file_url")) {
            depositData.file_url = depSupData[idx].file_url;
          }
        }
      }

      try {
        const res = await this.tagDeposit(depositData, client.id);
        if (localStorage.getItem("depositAnswers")) {
          let depSupData = JSON.parse(localStorage.getItem("depositAnswers"));
          let idx = depSupData.findIndex(id => id.client_id === client.id);
          if (idx > -1) {
            depSupData.splice(idx, 1);
            localStorage.setItem("depositAnswers", JSON.stringify(depSupData));
          }
        }
        this.$emit("updated");
        this.$store.commit("clients/setRequestForDate", {});
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: "REG",
          preset: null
        });

        this.showDepositForm = false;
        this.showForm = false;
        this.deposit.user_id = null;
        this.deposit.dep_date = null;
        this.deposit.call_broker_at = null;
        this.hideSecDepCalAfterDateChoosed = false;
        this.deposit.call_broker_at = "Invalid date";
        this.scDepDateCheckBox = false;
        this.optionClicked = null;
        this.optionClickedF1 = null;
        this.optionClickedF2 = null;
        this.optionClickedF3 = null;
        this.optionClickedF4 = null;
        this.optionClickedF5 = null;
        this.openCustomSelectF1 = false;
        this.openCustomSelectF2 = false;
        this.openCustomSelectF3 = false;
        this.openCustomSelectF4 = false;
        this.openCustomSelectF5 = false;
        this.scDepDateCheckBox = true;

        this.$set(this.deposit, "errors", {});
        if (!this.checkPermissions(this.auth, [1, 2, 3, 4, 12])) {
          if (this.client.questions_status < 2) {
            this.$emit("lock", this.client.id);

            this.$store.commit("clients/setUpdateDepCharts", true);
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg:
                "To continue work please answer all questions on client #" +
                client.id,
              type: "WARNING_BLOCK",
              op: { type: "SYSTEM" }
            });
          }
        }

        this.$store.commit("clients/setLoading", false);
        if (depositData.status_id !== 4 && depositData.status_id !== 6) {
          let depCountPerUserToday = `#1`;
          await apiClientCreator(`client/stats/tag/dep/user/0`)
            .get("", {
              params: {
                deposit_clients: true,
                deposit_users: [this.auth.user.id],
                deposit_at_from: moment().format("YYYY-MM-DD"),
                deposit_at_to: moment().format("YYYY-MM-DD")
              }
            })
            .then(result => {
              if (result.data.length > 0) {
                // if (result.data.length < 10) {
                //   depCountPerUserToday = this.getWordFromNumber(
                //     result.data[0].overall_count
                //   );
                // } else {
                depCountPerUserToday = `#${result.data[0].overall_count}`;
                // }
              }
            })
            .catch(err => {});
const message = `Dep in  ${this.findBrokerNameByID(depositData.campaign_id)},\nby ${this.auth.user.first_name}  ${this.auth.user.last_name }\n${depCountPerUserToday}'s today`
          this.msgSocket.emit("receive_message", {
            message_from: this.auth.user.id,
            message: message, //Great job for making a deposit in ${this.findBrokerNameByID(depositData.campaign_id)}; ${client.country.name},  `,//- left to your goal ${depositData.amount} `,
            priority: 9,
            type: "USER_DEPOSITED",
            op: { clientId: client.id },
            options: { countryAlpha: client.country.alpha2 }
          });
          // console.log(client.is_duplicate);
          // console.log(client.duplicate.group_id);
          // console.log(client.duplicate.group_id.id);
          // console.log(client.ni);

          //Checking if the client have duplicate and the duplicate was NI, or the client is NI (without duplicate), if so, emit to all users.
          if(((client.is_duplicate && client.duplicate.group_id) && client.duplicate.group_id.id===3) || client.ni.length){
            const agent_ni = this.salesPersonList.find(person=>person.id===client.ni[0].user.id)
            const agent_name_to_show = this.getOfficialName(agent_ni)
            const logged_user_to_show = this.getOfficialName(this.auth.user)
             this.msgSocket.emit("deposited_from_ni", {
              message_from: this.auth.user.id,
              message: `NI sale of ${agent_name_to_show}. \n made by ${logged_user_to_show} \n`,
              priority: 9,
              type: "USER_DEPOSITED_FROM_NI",
              op: { clientId: client.id },
              options: { countryAlpha: client.country.alpha2 }
            });

          }



          //  await this.$store.dispatch("clients/startTheTimer", false);
          // if (this.timer === "10") {
          this.sendSMSAfterDepRequest(depositData, client, res.data);
          if (
            this.CheckIfBrokerCountTwice(this.deposit.campaign_id) === 0 &&
            this.deposit.amount === 1000
          ) {
            this.sendSMSAfterDepRequest(depositData, client, res.data);
          }
          this.resetNewDepositFormForm();
          // }
        }
      } catch (e) {
        let errRes = "";
        if (e.response.status === "409" || e.response.status === 409) {
          errRes = "Deposit existing for this broker";
        } else {
          errRes = e.response.status;
        }
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: " Error Adding\n Deposit Tag: " + errRes,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    resetNewDepositFormForm() {
      this.deposit.campaign_id = null;
      this.deposit.currency_id = null;
      this.deposit.amount = 100;
      this.deposit.method_id = null;
      this.deposit.status_id = null;
      this.deposit.comment = "";
      this.deposit.call_broker_at = null;
    },
    CheckIfBrokerCountTwice(brokerId) {
      const broker = this.dictionaries.general.brokers.find(
        bro => bro.id === brokerId
      );
      return broker.count_twice;
    },

    formatDate(date) {
      return moment(String(date)).format("MM/DD/YY");
    },
    formatDateTime(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY");
    },
    sendDpAutoEmail(data, client) {
      if (this.CheckUserPermission([1, 2])) {
        const sendSMSReq = apiClientCreator(
          `client/emailAutoDp/send/${client.id}`
        );
        sendSMSReq
          .post("", {
            client_email: client.emails[0].contact_value,
            full_name: client.full_name,
            campaign_id: data.campaign_id,
            fName: client.first_name,
            lName: client.last_name
          })
          .then(e => {});
      }
    },
    sendEmailAutoNa(client, preset, type) {
      if (this.CheckUserPermission([1, 2])) {
        const sendSMSReq = apiClientCreator(
          `client/emailAutoNa/send/${client.id}`
        );
        sendSMSReq
          .post("", {
            preset_id: preset.id,
            contact_value: client.phones[0].contact_value,
            client_email: client.emails[0].contact_value,
            fName: client.first_name,
            lName: client.last_name,
            type: type,
            message:
              client.full_name +
              ", " +
              preset.preset +
              " " +
              client.assignment.assigned_to.full_name +
              " ",
            link: `${Globals.joomla_website}mail.php?id=${client.id}`
          })
          .then(e => {
            if (e.data) {
              if (e.data === "email AutoNaSent") {
                this.$emit("naAutoEmailSent");
              } else if (e.data === "client has not replied") {
                this.$emit("naAutoEmailNotReYet");
              }
            }
            this.$emit("updated");
          });
      }
    },

    sendSMSPresetRequest(client, preset, type) {
      const sendSMSReq = apiClientCreator(`client/sms/send/${client.id}`);
      sendSMSReq
        .post("", {
          preset_id: preset.id,
          contact_value: client.phones[0].contact_value,
          type: type,
          message:
            client.full_name +
            ", " +
            preset.preset +
            " " +
            client.assignment.assigned_to.full_name +
            " " +
            `${Globals.joomla_website}sms.php?id=${client.id}`
        })
        .then(() => {
          this.sendEmailAutoNa(client, preset, type);
          this.$emit("updated");
        });
    },

    sendEmailPresetRequest(client, preset) {
      const sendSMSReq = apiClientCreator(`client/email/send/${client.id}`);
      sendSMSReq
        .post("", {
          preset_id: preset.id,
          contact_value: client.emails[0].contact_value,
          fName: client.first_name,
          lName: client.last_name,
          message:
            client.full_name +
            ", " +
            preset.preset +
            " " +
            client.assignment.assigned_to.full_name +
            " ",
          link: `${Globals.joomla_website}mail.php?id=${client.id}`
        })
        .then(() => {
          this.$emit("updated");
        });
    },
    formatDateFakeTag(date) {
      return `${moment(date).format("hh:mm")} ${moment(date).format("DD/MM")}`;
    },
    getDayTime() {
      const format = "hh:mm:ss";
      const time = moment();
      const morningStart = moment("05:01:00", format);
      const morningEnd = moment("11:00:00", format);
      const afternoonStart = moment("11:01:00", format);
      const afternoonEnd = moment("16:00:00", format);
      const eveningStart = moment("16:01:00", format);
      const eveningEnd = moment("22:00:00", format);
      const nightStart = moment("22:01:00", format);
      const nightEnd = moment("23:59:00", format);
      const nightStart2 = moment("00:00:00", format);
      const nightEnd2 = moment("05:59:00", format);

      if (time.isBetween(morningStart, morningEnd)) {
        return "Good Morning";
      }

      if (time.isBetween(afternoonStart, afternoonEnd)) {
        return "Good Afternoon";
      }

      if (time.isBetween(eveningStart, eveningEnd)) {
        return "Good Evening";
      }

      if (
        time.isBetween(nightStart, nightEnd) ||
        time.isBetween(nightStart2, nightEnd2)
      ) {
        return "Good Night";
      }
    },
    findBrokerEmailByID(brokerId) {
      return this.dictionaries.general.brokers.find(
        item => item.id === brokerId
      ).support_email;
    },
    findBrokerNameByID(brokerId) {
      return this.dictionaries.general.brokers.find(
        item => item.id === brokerId
      ).name;
    },
    findUserNameByID(userId) {
      return this.salesPersonList.find(item => item.id === userId).full_name;
    },
    findCurrencySymbolByID(curId) {
      return this.dictionaries.activity.currency_types.find(
        item => item.id === curId
      ).symbol;
    },
    async getSuggestedUsers(client, transferType = false) {
      try {
        const res = await apiClientCreator(
          `reports/campaigns/performance/suggested`
        ).post("", { data: client, transfer_type: transferType });
        let keys = Object.keys(res.data);
        this.uniqueUsers = [];
        for (let i = 0; i < this.salesPersonList.length - 1; i++) {
          if (!keys.includes(this.salesPersonList[i].id.toString())) {
            this.uniqueUsers.push(this.salesPersonList[i]);
          }
        }
        this.suggestedUsers = keys.sort(function(a, b) {
          return res.data[b] - res.data[a];
        });
        let suggested = [];
        let unSuggested = [];
        for (let key in keys) {
          let user = {};
          user["score"] = res.data[this.suggestedUsers[key]];
          user["data"] = this.salesPersonList.find(
            item => item.id === parseInt(this.suggestedUsers[key])
          );
          if (user["score"] > 0) {
            suggested.push(user);
          } else {
            unSuggested.push(user);
          }
        }
        this.suggestedUsers = suggested;
        this.unSuggestedUsers = unSuggested;
      } catch (e) {
        this.suggestedUsers = [];
        this.unSuggestedUsers = [];
        this.uniqueUsers = this.salesPersonList;
      }
    },

    sendSMSAfterDepRequest(data, client, resId) {
      const sendSMSReq = apiClientCreator(
        `client/sms/deposit/send/${client.id}`
      );
      sendSMSReq.post("", {
        day_time: this.getDayTime(),
        user_id: data.hasOwnProperty("user_id")
          ? data.user_id
          : this.auth.user.id,
        message:
          `did a New Deposit: ` +
          this.formatDateTime(moment()) +
          " | " +
          client.country.name +
          " | " +
          data.amount +
          this.findCurrencySymbolByID(data.currency_id) +
          " | " +
          this.findBrokerNameByID(data.campaign_id) +
          " | " +
          " #" +
          client.id
      });

      if (this.CheckUserPermission([1, 2])) {
        this.sendDpAutoEmail(data, client);
      }

      /*              .catch(e =>{
                          this.$store.commit("main/setShowVikiMsg", {
                            show: true,
                            msg: "Sent SMS To Client Error " + e.response.status,
                            type: "ERROR"
                          });
                          this.$store.commit("clients/setLoading", false);
                        })*/
    },
    async tagNA(selectedTag, clientId, isVm) {
      const apiClient = apiClientCreator(`client/na/${clientId}`);
      await apiClient.post("", { tag_id: selectedTag.id, is_vm: isVm });
    },

    async untagNA(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/na/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },

    async untagScheduledCall(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/schedule-call/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },
    async tagLead(lead, clientId) {
      const apiClient = apiClientCreator(`client/lead/${clientId}`);
      await apiClient.post("", lead);
    },

    async untagLead(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/lead/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },

    async tagDeposit(deposit, clientId) {
      const apiClient = apiClientCreator(`client/deposit/${clientId}`);
      return await apiClient.post("", deposit);
    },

    async untagDeposit(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/deposit/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },

    async tagAddCommunication(commContactedIn, tagTypeIdNum, clientId) {
      const apiClient = apiClientCreator(`client/communication/${clientId}`);
      await apiClient.post("", {
        contacted_in: commContactedIn,
        comm_type_id: tagTypeIdNum
      });
    },

    async untagCommunication(commIdNum, clientId) {
      const apiClient = apiClientCreator(`client/communication/${clientId}`);
      await apiClient.delete("", { data: { comm_id_num: commIdNum } });
    },

    async tagReferral(clientId, referral) {
      const apiClient = apiClientCreator(`client/referral/${clientId}`);
      await apiClient.post("", referral);
    },

    async untagReferral(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/referral/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },

    async tagLanguage(clientId, langId) {
      const apiClient = apiClientCreator(`client/language/${clientId}`);
      await apiClient.put("", { lang_id: langId });
    },
    async untagLanguage(clientId) {
      const apiClient = apiClientCreator(`client/language/${clientId}`);
      await apiClient.delete("");
    },
    async tagBN(selectedTag, clientId) {
      const apiClient = apiClientCreator(
        `client/bad-number/${clientId}`,
        "token"
      );
      await apiClient.post("", { tag_id: selectedTag.id });
    },

    async untagBN(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/bad-number/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },
    async tagNI(selectedTag, clientId) {
      const apiClient = apiClientCreator(`client/not-interested/${clientId}`);
      await apiClient.post("", { tag_id: selectedTag.id });
    },

    async untagNI(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/not-interested/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },

    async tagWaiting(clientId) {
      const apiClient = apiClientCreator(`client/waiting/${clientId}`);
      await apiClient.put("");
    },

    async untagWaiting(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/waiting/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },

    async tagEnded(clientId) {
      const apiClient = apiClientCreator(`client/ended/${clientId}`);
      await apiClient.put("");
    },

    async untagEnded(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/ended/${clientId}`);
      await apiClient.delete("", { data: { tag_id_num: tagIdNum } });
    },
    async tagTransfer(clientId, transferPayload) {
      const apiClient = apiClientCreator(`client/transfer/${clientId}`);
      await apiClient.post("", transferPayload);
    },

    async untagTransfer(tagIdNum, clientId) {
      const apiClient = apiClientCreator(`client/transfer/${clientId}`);
      await apiClient.delete("", { data: { transfer_id_num: tagIdNum } });
    },

    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },

    async addNewTask(task) {
      // @accepted="$emit('task',{assign_to:newTask.taskUser, priority_id:newTask.taskPriority.id, content:newTask.taskText, due_date:newTask.taskDateTime, deposit_id:deposit.id })"

      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(`tasks/new`);

        let ids = [];
        task.assign_to.forEach(function(item) {
          ids.push(item.id);
        });
        const newTask = {
          type_id: 1,
          assign_to: ids,
          priority_id: task.priority_id,
          content:
            "#" +
            this.client.id +
            " | " +
            this.client.country.name +
            " | " +
            this.findBrokerNameByID(task.deposit.campaign_id) +
            " | " +
            ` Deposit: #${task.deposit.id}` +
            " | " +
            task.content,
          time_quantity: 24, // DUMP
          start_time: task.due_date,
          end_time: moment(task.due_date).add(15, "minutes"),
          cat_arr: [Globals.dep_task_cat_id]
        };

        await addNewClientRequest.post("", newTask);
        // this.cancelAddTask();
        this.$emit("updated");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "New Task Added successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error Adding Task " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/*.client-tags{*/
/*  width: 100%;*/
/*}*/
.tag {
  cursor: default;
}

.tag-bad-number {
  font-size: 9pt;
  background-color: black;
  color: white;
  margin: 0;
  padding: 3px;
  border-radius: 5px;
  font-family: "Montserrat" !important;
  border-radius: 0px;
}

.tag-bad-number {
  font-size: 9pt;
  background-color: #424242;
  color: white;
  margin: 0;
  font-weight: 500;
  font-family: "Montserrat" !important;
  padding: 3px;
  border-radius: 0px;
}

.add-tag-wrapper {
  position: relative;
  display: inline;
  float: left;
  margin-left: -5px;
  margin-top: 1px;
  cursor: pointer;
  font-family: "Montserrat" !important;
  margin-top: 6px;
  /*font-size: 1em;*/
  /*z-index: 10001;*/

  /*  position: relative;
    display: inline;
    float: left;
    margin-right: 4px;
    margin-top: -1px;
    cursor: pointer;
    font-family: "Montserrat" !important;
    font-size: 2em;*/
  /*z-index: 10001;*/
}

.activity-button-wrap {
  margin-top: 12px;
}

.btn-add {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid transparent;
  /*background-image: url("../../../../../assets/svg_icons/add_tag.svg");*/
  background-repeat: no-repeat;
}

.btn-add-disabled {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid transparent;
  /*background-image: url("../../../../../assets/svg_icons/add-disabled.svg");*/
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: default;
}

.btn-cancel {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid transparent;
  background-image: url("../../../../../assets/svg_icons/cancel.svg");
  background-repeat: no-repeat;
  margin-right: 10px;
}

.select-tag-div {
  display: flex;
}

.tag-select {
  margin-right: 15px;
  width: 100%;
  height: 30px;
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  /*border-radius: 5px;*/
  color: #90a4ae;
  background: #fff;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  background: url(../../../../../assets/svg_icons/tag-black-shape.svg) no-repeat
    right #fff;
  background-size: 18px;
  background-position: 95% 4px;
  font-family: "Montserrat" !important;
}

.floating-new-lead-details {
  position: absolute;
  top: -15px;
  right: 40px;
  width: 270px;
  z-index: 100;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  /*-webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  /*-moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  /*box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
}
.mx-datepicker-content {
  z-index: 2500 !important;
}
.floating-transfer-form {
  position: absolute;
  top: -154px;
  right: 22px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  cursor: default;
  z-index: 100;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  /*-webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  /*box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
}

.floating-new-deposit-details {
  position: absolute;
  top: -185px;
  right: 40px;
  width: max-content;
  z-index: 100;
  padding: 10px;
  background-color: #fff;
  border: solid 1px rgba(136, 119, 119, 0.3);
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  min-width: 261px;
}

.floating-schedule-call-details {
  position: absolute;
  top: 18px;
  right: -5px;
  width: 240px;
  z-index: 100;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.floating-lang-options {
  position: absolute;
  top: 18px;
  right: 30px;
  width: max-content;
  z-index: 100;
  padding: 10px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.sec_drop_tra_to {
  font-weight: 400;
  width: 100%;
  height: 100%;
  padding: 0px;
  /* padding-top: 3px; */
  list-style: none;
  left: -446px;
  top: 2px;
  z-index: 100;
  border-radius: 0;
  font-size: 12px !important;
  height: auto;
  max-height: 300px;
  /*overflow-x: hidden;*/
  /*max-width: 220px;*/
  overflow-y: scroll;
  /*display: none;*/
  box-sizing: content-box;
  padding-right: 31px !important;
}

.sec_drop_tra_to li {
  padding-top: 4px;
  font-size: 12px !important;
  list-style: none;
  font-size: 11px;
  text-transform: uppercase;
  text-align: left;
  padding: 7px;
  list-style-type: none;
  margin-bottom: 0px;
}

.sec_drop_tra_to ul {
  margin-left: -38px;
}
.sec_drop_tra_to span {
  font-weight: 600;
  font-size: 14px;
}
.sec_drop_tra_to li:hover {
  background-color: lightgrey !important;
}
.d-m {
  font-weight: 400;
  /*width: 190px;*/
  padding: 0px;
  /* padding-top: 3px; */
  height: auto;
  list-style: none;
  left: -446px;
  top: 2px;
  z-index: 10001;
  border-radius: 0;
  font-size: 12px !important;
  /*display: none;*/
}
.d-m li {
  padding-top: 4px;
}
.d-m li:hover {
  background-color: lightgrey;
}
.dm {
  width: unset !important;
  padding: 5px;
  height: auto;
  left: 0 !important;
  top: 35px !important;
  z-index: 100 !important;
  border-radius: 0;
  font-size: 12px !important;
}
.dropdown-menu {
  /*<!--width: 236px;-->*/
  /*<!--padding: 5px;-->*/
  /*<!--height: auto;-->*/
  /*<!--left: -294px;-->*/
  /*<!--top: -278px;-->*/
  /*<!--z-index: 100 !important;-->*/
  /*<!--border-radius: 5px;-->*/
  /*<!--font-size: 12px !important;-->*/

  /* width: auto;
  padding: 5px;
  height: auto;
  left: -395px;
  top: 2px;
  border-radius: 0;
  font-size: 12px !important;*/
  /* border: solid 1px #e4e8ea; */
  /* -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
  width: fit-content;
  min-width: 236px;
  max-width: 283px;
  height: auto;
  left: -274px;
  top: -250px;
  border: none;
  z-index: 100 !important;
  border-radius: 5px;
  font-size: 12px !important;
}

.dropdown-menu.for-un-closing {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.15);
  border: 1px solid #e2e8f0;
  padding: 8px;
  min-width: 260px;
  background: white;
}

.add-tag-menu-item {
  margin: 6px;
  font-size: 12px !important;
  text-transform: uppercase !important;
}

.add-tag-menu-item-title {
  /*margin: 5px;*/
  /*font-size: 12px !important;*/
  /*text-transform: uppercase !important;*/
  /*font-weight: bold;*/
  /*margin: 5px;*/
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
}

.add-tag-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

/*.dropdown-divider {*/
/*  height: 1px;*/
/*  margin: 9px 0;*/
/*  overflow: hidden;*/
/*  background-color: #e5e5e5;*/
/*}*/

.text-counter-scheduled {
  float: left;
  font-size: 8pt;
}

.text-counter-lead {
  float: left;
}

.cancel-edit-menu-item {
  color: #f44336;
  font-weight: bold;
}

.edit-menu-item {
  /*font-weight: bold;*/
}

.lang-dropdown {
  padding: 5px;
  height: auto;

  max-height: 200px;
  overflow-x: hidden;
}

select {
  width: 100%;
  height: 30px;
  position: relative;
  display: inline-block;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  padding: 5px;
  border-width: thin;
  color: black;
  background: #fff;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 9pt;
  font-family: Montserrat;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  outline: none !important;
  border: 1px solid lightgrey !important;
}
input[data-v-00c5784c] {
  font-size: 9pt;
  text-transform: uppercase;
  overflow-x: auto;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding-left: 6px;
  /*min-width: -webkit-fill-available;*/
}

input.input-standard {
  min-width: 195px;
  margin: 0 !important;
  font-weight: 500;
  float: left;
}
input.input-standard-for-dep {
  min-width: 219px;
  margin: 0px 0 12px 0 !important;
  font-weight: 500;
  float: left;
}
input.input-standard-bn-lan-ex-ni{
  min-width: 256px;
  margin: 12px 0 12px 0 !important;
  padding: 10px;
  font-weight: 500;
  float: left;
}
input.input-standard-ni{
  min-width: 238px;
  margin: 12px 0 12px 0 !important;
  padding: 10px;
  font-weight: 500;
  float: left;
}
input {
  border: 1px solid lightgrey !important;
  margin: 5px !important;
}
input[type="button"] {
  border-radius: 0;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
}
input[type="button"]:focus {
  outline: none;
}
input[type="search"]:active {
  cursor: pointer !important;
}
input[type="search"]:focus,
textarea:focus {
  /*box-shadow: 0 0 5px rgba(81, 203, 238, 1);*/
  /*!*padding: 3px 0px 3px 3px;*!*/
  outline: none !important;
  cursor: pointer !important;

  /*border: 1px solid lightgrey !important;*/
  /*margin: 5px !important;*/
}

input :not(.date-check-box) {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  margin-bottom: 5px;
}

.tag-block {
  display: inline;
}

.tager {
}

.dot-green {
  height: 10px;
  width: 10px;
  background-color: #64dd17;
  border-radius: 50%;
  display: inline-block;
  margin-left: 11px;
  margin-right: -5px;
}

.dot-yellow {
  height: 10px;
  width: 10px;
  background-color: #ffd600;
  border-radius: 50%;
  display: inline-block;
  margin-left: 11px;
  margin-right: -5px;
}

.dot-red {
  height: 10px;
  width: 10px;
  background-color: #d50000;
  border-radius: 50%;
  display: inline-block;
  margin-left: 11px;
  margin-right: -5px;
}

.floating-answer-traffic-lights {
  position: absolute;
  top: 20px;
  right: 0px;
  width: max-content;
  z-index: 100;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.answer-traffic-lights-wrapper {
}

.dropdown-menu-tags {
  float: right;
  list-style: none;
  /* padding: 6px; */
  /* -webkit-box-orient: horizontal; */
  /* align-content: center; */
  text-align: right;
  /* top: 12px; */
}

.input-sc-status {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  margin-top: 5px;
  margin-bottom: 5px;
  /*border-radius: 5px;*/
  margin-left: 0 !important;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  box-sizing: border-box;
}

.floating-sc-options {
  position: absolute;
  top: 80px;
  left: -89px;
  width: max-content;
  z-index: 100;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-pr-options {
  position: absolute;
  top: 120px;
  left: 10px;
  width: max-content;
  z-index: 100;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.sc-dropdown {
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}

.pr-dropdown {
  padding: 0 3px 0 3px;
  margin-bottom: -5px;
  margin-top: -5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}

.date-box-trans {
  margin-bottom: 10px;
}
.panel-group {
  margin-bottom: 0;
}

.nav {
  /*height: 40px;*/
  /*margin-bottom: 0px;*/
  /*padding-left: 32px;*/
  height: 40px;
  margin-bottom: 0px;
  /* padding-left: 42px;*/
}
hr.style2 {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(26, 25, 25, 0),
    rgb(203, 219, 233),
    rgba(0, 0, 0, 0)
  );
  margin: 0px;
}

/*.nav-tabs a {
  height: 20px;
  padding: 5px;
  font-size: 12px !important;
  text-transform: uppercase !important;
}*/

.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom-color: #ffffff;
  font-weight: bold;
  color: black;
}

.nav-tabs li {
  margin-right: 1px;
  font-size: 10px;
}

.tab-stats {
  font-size: 7pt;
}

.btn-trans-confirm-box {
  text-align: center;
  margin-bottom: 15px;
}
.btn-trans-confirm {
  right: 25px;
  /*color: black !important;*/
  background-color: white !important;
  border-color: white;
  border-radius: 15px;
  /* padding: 4px !important; */
  max-width: 35px;
  /* margin-left: 16px; */
  margin-top: 3px;
  position: absolute;
}
.bttn {
  font-family: Montserrat !important;
  width: fit-content;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 11px;
  /*font-family: inherit;*/
  cursor: pointer;
}

.apply-tr-color {
  color: #827717;
}

.apply-na-color {
  color: #f4511e;
}

.apply-ca-color {
  color: #fa8100;
}

.apply-ni-color {
  color: #424242;
}

.apply-bn-color {
  color: #000;
}

.apply-ld-color {
  color: #1144bc;
}

.apply-dep-color {
  color: #7b1fa2;
}

.apply-rf-color {
  color: #d32f2f;
}

.apply-comm-color {
  color: #e5be37;
}

.apply-lang-color {
  color: #929292;
}
.suggested-users {
  background: yellow;
  /*color: white;*/
  font-family: "Montserrat" !important;
  margin-left: 38px !important;
}
.unsuggested-users {
  background: #f4511e;
  color: white;
  font-family: "Montserrat" !important;
  cursor: pointer !important;
}
.sc-date-span {
  font-size: 12px;
  padding-left: 5px;
}
.qs-warning {
  text-align: center;
  color: #4d0000;
  font-size: 12px;
  margin-top: 4px;
}
.dep-qs-form {
  text-align: left;
  margin-top: 8px !important;
  padding: 0px;
  display: flex;
}

.quest-inline {
  text-align: left;
  //margin-top:0px !important;
  margin: 0px 0px 5px 3px;
}

.quest-line-bold {
  font-size: 11px;
  font-weight: bold !important;
  display: inline;
}

.sup-table {
  table {
    width: 100%;
  }
  .sup-question {
    font-size: 12px;
    font-weight: bold !important;
    /*display: inline; */
  }
  .sup-answer {
    font-size: 12px;
    text-align: center;
  }
  .remove-border {
    outline: none !important;
    /*border: 1px solid lightgray !important;*/
  }

  .add-tag-wrapper .dropdown div.dropdown-menu input.extra-things {
    /*
    outline: none !important;
*/
    width: 420px;
  }

  .extra-things {
    /*width: 420px;*/
    /*margin-left: 233px !important;*/
  }

  ::placeholder {
    font-family: Montserrat;
    font-size: 11px;
  }
  .assignment-dropdown-menu {
    border: solid 1px #90a4ae;
    /*  border-radius: 0;
      -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
      box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  }
  .input-standard {
    width: 100%;
    position: relative;
    display: inline-block;
    padding: 4px 4px 4px 10px;
    //border-radius: 4px;
    border: 1px solid #dee2e6;
    height: 30px;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
    box-sizing: border-box;
    font-weight: normal;
  }


  /*style="list-style-type: none;*/
  /*font-size: 12px;font-family: Montserrat;*/
  /*font-weight: 400;padding: 4px 0px;"*/
  /*.input-standard div ul .searchR{*/
  /*  list-style-type: none !important;*/
  /*  font-size: 12px !important;*/
  /*  font-family: Montserrat !important;*/
  /*  font-weight: 400 !important;*/
  /*}*/
}
ul.searchR {
  list-style-type: none;
  font-size: 12px;
  font-family: Montserrat;
}
ul.searchR li {
  padding: 2px 0px;
}
ul.searchR li:hover {
  background-color: lightgrey !important;
}
hr {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  border: 0px !important;
}
.d-m li {
  cursor: pointer;
}
.forAllCli {
  cursor: pointer !important;
}
.overH {
  overflow: hidden !important;
}
i.fas.fa-ellipsis-h {
  padding-left: 5px !important;
  cursor: pointer;
}
.forTheRestTags {
  height: auto;
  padding-top: 2px;
  width: auto;
  justify-content: right !important;
  text-align: right !important;
  position: absolute;
  right: 7px !important;
  z-index: 10001;
  background-color: #fff;
}
.forTheRestTags .tag-wrapper {
  display: block;
  margin-bottom: 5px !important;
}
.moveIt {
  position: absolute;
  right: 31px;
  top: 24px;
}
.tag-endedNew {
  /*background-color: #004d40;*/
  /*font-size: 12px;*/
  /*!* margin: 1px; *!*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/

  background-color: #004d40;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-transfer {
  /*background-color: #ab9b0c;*/
  /*font-size: 12px;*/
  /*color: white;*/
  /*!* font-size: 11px; *!*/
  /*margin: 2px;*/
  /*padding: 3px;*/
  /*width: 72px;*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*font-family: Montserrat !important;*/
  /*font-weight: 500;*/
  /*-webkit-animation: flash-data-v-76c50849 linear 1s;*/
  /*animation: flash-data-v-76c50849 linear 1s;*/
  /*!* height: 178px; *!*/
  /*float: right;*/
  /*border: 1px solid white;*/
  /*border-right: 5px;*/

  background-color: #ab9b0c;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-scheduled-call-newV {
  /*background-color: #ffa400;*/
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #ffa400;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-na-newV {
  /*background-color: #f4511e;*/
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #f4511e;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  /*float: right;*/
}
.tag-na-newV:hover {
  background-color: grey;
}
.tag-lead-newV {
  /*background-color: #4275ec;*/
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #4275ec;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-referral-newV {
  /*background-color: #af3131;*/
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #af3131;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-deposit-newV {
  /*background-color: #ae3ede;*/
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #ae3ede;
  font-size: 12px;
  /* margin: 2px; */
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  /* font-size: 11px; */
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}

.tag-language-newV {
  /*background-color: #bdbdbd;*/
  /*font-size: 12px;*/
  /*!*margin: 1px;*!*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #bdbdbd;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-edit-newV {
  background-color: #fff;
  border: 1px solid black;
  font-size: 12px;
  /*margin: 1px;*/
  font-weight: 500;
  padding: 3px;
  /* font-size: 11px; */
  line-height: 1.5;
  cursor: pointer;
  color: black;
  width: 72px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-edit-newV:hover {
  color: black !important;
}
.tag-com-newV {
  /*background-color: #eabf3e;*/
  /*font-size: 12px;*/
  /*!*margin: 1px;*!*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #eabf3e;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-ni-newV {
  /*background-color: #000000;*/
  /*font-size: 12px;*/
  /*!*margin: 1px;*!*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/

  background-color: #000000;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
.tag-bn-newV {
  /*background-color: #000000;*/
  /*font-size: 12px;*/
  /*!*margin: 1px;*!*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!* font-size: 11px; *!*/
  /*line-height: 1.5;*/
  /*cursor: pointer;*/
  /*color: white;*/
  /*width: 72px;*/
  /*font-family: "Montserrat" !important;*/
  /*-webkit-animation: flash-data-v-4100b2de linear 1s;*/
  /*animation: flash-data-v-4100b2de linear 1s;*/
  /*float: right;*/
  background-color: #000000;
  font-size: 12px;
  font-weight: 500;
  padding: 3px;
  border: 1px solid white;
  line-height: 1.5;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 45px;
  font-family: "Montserrat" !important;
  -webkit-animation: flash-data-v-4100b2de linear 0.5s;
  animation: flash-data-v-4100b2de linear 0.5s;
  float: right;
}
h4 > a {
  font-size: 12px;
}
h4 {
  line-height: unset !important;
}
.form-group div select {
  margin-bottom: 6px;
  border-radius: unset;
  border-color: lightgrey;
}
.panel-heading {
  background-color: white;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s;
}
.panel-heading:hover {
  background: #f8fafc;
}
.p2 {
  background-color: #f4511e;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}
.p3 {
  background-color: #f4511e;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}
.p2:hover {
  transform: scale(1.05);
}
.p3:hover {
  transform: scale(1.05);
}
.forSkype {
  height: 100px;
}
.quest-line-bold:nth-child(1) {
  padding-right: 5px;
  margin-left: -16px !important;
}

.cap-lt {
  text-transform: uppercase;
}
.panel-default {
  border-color: white !important;
  min-width: 278px !important;
}
i.fas.fa-ellipsis-h {
  padding-left: 5px !important;
  cursor: pointer;
}
.forTheRestTags {
  height: auto;
  padding-top: 2px;
  width: auto;
  justify-content: right !important;
  text-align: right !important;
  position: absolute;
  right: 7px !important;
  z-index: 10001;
  background-color: #fff;
}
.forTheRestTags .tag-wrapper {
  display: block;
  margin-bottom: 5px !important;
}
.moveIt {
  position: absolute;
  right: 31px;
  top: 24px;
}
.fa-1xx {
  font-size: 20px;
  vertical-align: middle;
}
/*.dateFromCal {*/
/*  font-size: 12px;*/
/*  padding-left: 28%;*/
/*  font-weight: 400;*/
/*  border-bottom: 1px solid lightgray;*/
/*  margin-bottom: 2px;*/
/*}*/
.forSecDepCal {
  padding-left: 30%;
}
.hideIt {
  display: none;
}
/*.client-tags div .tag-block:nth-of-type(1n+7) {display: none;}*/
.dep-count-today {
  color: #b5730e;
}
/*.hajTemp{*/
/*  background-color: lightgrey;*/
/*  border-radius: 50px;*/
/*  !*padding: 5px;*!*/

/*}*/
.newPlusBtn {
  width: 24px;
  height: 24px;
  background: #3b82f6;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}
.newPlusBtn:hover {
  background: #1d4ed8;
  transform: scale(1.1);
}
.forPlus {
  margin-top: -6px;
  position: relative;
}
.carousel-control {
  width: 1% !important;
}
.carousel-inner {
  margin-left: 2px !important;
  margin-right: 2px !important;
  overflow: unset !important;
}
.carousel-control.left,
.carousel-control.right {
  background-image: none;
}
/*.temp{*/
/*  position: absolute;*/
/*}*/
.carousel-override {
  margin-left: 30px !important;
}
.carousel-control {
  color: #494a4a;
  text-shadow: none !important;
}
.panel-collapse {
  min-height: 45px !important;
  border-radius: 3px !important;
}
.panel-title a {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  text-decoration: none;
}
.dp .panel-title a,
.tr .panel-title a,
.ca .panel-title a,
.ld .panel-title a,
.rf .panel-title a,
.bn .panel-title a,
.lng .panel-title a,
.com .panel-title a,
.ni .panel-title a,
.end .panel-title a,
.p2 .panel-title a,
.p3 .panel-title a {
  color: white;
}
.dp {
  background: #ae3ede !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.dp:hover {
  transform: scale(1.05);
}
.tr {
  background: #ab9b0c !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.tr:hover {
  transform: scale(1.05);
}
.ca {
  background: #ffa400 !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.ca:hover {
  transform: scale(1.05);
}
.ld {
  background: #4275ec !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.ld:hover {
  transform: scale(1.05);
}
.rf {
  background: #af3131 !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.rf:hover {
  transform: scale(1.05);
}
.bn {
  background: #000000 !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.bn:hover {
  transform: scale(1.05);
}
.lng {
  background: #bdbdbd !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.lng:hover {
  transform: scale(1.05);
}
.com {
  background: #eabf3e !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.com:hover {
  transform: scale(1.05);
}
.ni {
  background: #000000 !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.panel-collapse-ni {
  max-height: 275px;
  overflow-x: auto;
}
.panel-collapse-tr {
  max-height: 275px;
  overflow-x: auto;
}
.panel-collapse-bn {
  max-height: 275px;
  overflow-x: auto;
}

.panel-collapse-lang {
  max-height: 275px;
  overflow-x: auto;
}

.ni:hover {
  transform: scale(1.05);
}
.end {
  background: #004d40 !important;
  min-height: 45px !important;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
}
.end:hover {
  transform: scale(1.05);
}
.fa-edit {
  font-size: 20px;
  margin-left: 45%;
  transition: all 0.2s ease-in-out;
}
.fa-edit:hover {
  transform: scale(1.3);
}
.panel-group .panel + .panel {
  margin-top: 3px !important;
}
.dp.panel-title a:nth-child(1) {
  margin-top: 3px !important;
}
.tr.panel-title a:nth-child(1) {
  margin-top: 3px !important;
}
.panel-default {
  margin-top: 3px;
}
a:hover {
  text-decoration: none;
}
.hoverOnBn:hover {
  background-color: lightgrey;
}
.hoverOnNi:hover {
  background-color: lightgrey;
}
.hoverOnTr:hover {
  background-color: lightgrey;
}
.hoverOnComm:hover {
  background-color: lightgrey;
}
.hoverOnLang:hover {
  background-color: lightgrey;
}

.add-tag-wrapper-status {
  margin-top: 1px;
}
.naOnly {
  margin-left: 97px !important;
  margin-right: 12px;
}
.naOnly:hover {
  background-color: grey;
}
.expansionData {
  color: white;
  margin-left: 52px !important;
}
.tag-scheduled-call {
  background-color: #ffa400;
}
.label {
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 6px;
  font-weight: 500;
}
div.fake-tag {
  display: inline-flex !important;
  min-width: 128px !important;
}
/*label.tag-scheduled-call.table-tag-content.fake-tag {*/
/*  min-width: 40px !important;*/
/*}*/
.blinking {
  -webkit-animation: 2s blink ease-in-out infinite;
  -moz-animation: 2s blink ease-in-out infinite;
  -ms-animation: 2s blink ease-in-out infinite;
  -o-animation: 2s blink ease-in-out infinite;
  animation: 2s blink ease-in-out infinite;
  animation: 2s blink ease-in-out infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

@-moz-keyframes blink {
  from,
  to {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

@-webkit-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@-ms-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@-o-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}
/*
  .fake-sand-clock{
    border: 1px solid white;
    border-radius: 5px;
    padding: 3px 7px;
    margin-right: 5px;
    margin-left: -5px;
  }
.fake-sc-date{
  margin-right: 20px;
}
*/
.panel-body.hoverOnNi {
  border-top-color: white !important;
}
.panel-body.hoverOnComm {
  border-top-color: white !important;
}
.panel-body.hoverOnLang {
  border-top-color: white !important;
}
.panel-body.hoverOnTr {
  border-top-color: white !important;
}
.textAreaDp {
  background-color: #e3e8ea;
  border: 1px dotted !important;
}
.textAreaDp::placeholder {
  color: black;
}
.textAreaLd {
  ackground-color: #e3e8ea;
  border: 1px dotted !important;
}
.textAreaLd::placeholder {
  color: black;
}

.add-tag-menu-item-title {
  /* margin-left: 8px; */
  font-size: 9pt;
  /* font-weight: bold; */
  text-transform: uppercase;
  /* max-width: 120px; */
  max-height: 154px;
  /* list-style-type: none; */
  overflow-x: auto;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding-top: 8px;
  padding-left: 6px;
  /* text-align: center; */
}

.assign-menu-item {
  /*margin: 5px;*/
  font-size: 11px;
  text-transform: uppercase;
  text-align: left;
  padding: 7px;
  list-style-type: none;
  margin-bottom: 0px;
}

.assign-menu-item:hover {
  background: #f3f2f2;
  cursor: pointer;
}
.assign-menu-item:nth-child(even):hover {
  background: lightgrey;
  cursor: pointer;
}

.add-tag-menu-item-title ul:nth-child(even),
.add-tag-menu-item-title ul li:nth-child(even) {
  background-color: #f3f2f2;
}
/*.add-tag-menu-item-title:first-child{*/
/*  margin-top: 5px;*/
/*}*/

.errColor {
  color: red;
}
.sum {
  top: -4.6px;
  left: -5px;
  position: relative;
  font-size: 9pt;
  text-transform: uppercase;
  height: 38px;
  overflow-x: auto;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding-top: -10px;
  padding-left: 6px;
  /* margin-bottom: 26px; */
  max-width: 45%;
  float: left;
  color: black;
}
.form-group.for-sum {
  margin-right: 4px;
  margin-left: -7px;
}
.add-tag-menu-item-title.for-cur {
  max-width: 50%;
}
.nav-btn {
  margin-top: 10px;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin-left: 4px;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: all 0.1s ease-in-out;
}
.nav-btn:hover {
  transform: scale(1.1);
}
.add-tag-menu-item-title.defInTr {
  min-height: 36px;
  color: grey;
}
.colored {
  color: black;
}
.mainCalNewV {
  margin-top: 15px;
}
.dep-qs-form-even {
  background-color: #f3f2f2;
}
.dep-qs-form-even:hover {
  background: lightgrey;
}
.dateFromCal-red {
  color: red;
}
.div-for-edit-only {
  position: absolute;
  top: -10px;
}
.for-com{
  max-height: 215px;
  overflow-y: scroll;
}
</style>
